<template>
  <div @contextmenu.stop.prevent="" id="viewer-content">
    <div id="bcd-productDetail-box"  :class="['z-container', 'bcd-productDetail-box', { showMore: isShowMore, hideTop: hideTop }]">
      <template v-if="oldStandardShow">
        <div class="clearfix content-box">
          <div class="btn-left" v-show="floorDetailShow.indexOf('left') > -1"></div>
          <div class="btn-right" v-show="floorDetailShow.indexOf('right') > -1"></div>
          <div class="close-left" v-show="isPC ? 'true' : showLeftMenu"></div>
          <div class="close-right" v-show="isPC ? 'true' : showRightMenu"></div>
          <!--左侧切换开始-->
          <left-tab v-show="isPC ? 'true' : showLeftMenu" v-if="floorDetailShow.indexOf('left') > -1" :Ind="leftTabInd" :tabActiveType="tabActiveType" :perNum="tabTopBottomLen" :tempNav="tempNavLeft" :navHeight="leftAndRightNavHeight" :nav="nodeNavLeft" @changeTab="changeFlowTab" />
          <!--左侧切换结束-->
          <div class="right-content fl" :style="{ width: isPC ? `calc(100% - ${186 * tabLeftRightLen + 1}px)` : '100%', border: floorDetailShow && floorDetailShow != 'down' ? '1px solid #dddddd' : 'none' }">
            <!--顶部切换开始-->
            <top-tab v-if="floorDetailShow.indexOf('up') > -1" :Ind="leftTabInd" :tabActiveType="tabActiveType" :tempNav="nodeNavTop" :nav="tempNavTop" @changeTab="changeFlowTab"></top-tab>
            <!--顶部切换结束-->
            <div class="commodity-show clearfix" ref="gallerysss" :style="{ padding: floorDetailShow && floorDetailShow != 'down' ? '18px' : '0px' }">
              <div class="commodity-pic">
                <div class="pic" style="position: relative; overflow: hidden">
                  <div id="commodity-pic">
                    <a href="https://www.520emv.com/oniid/#/?appId=BJYX">
                      <ZImage :value="picture ? picture : ''" :error-src="require('../assets/image/images/default_media.png')" />
                    </a>
                  </div>
                </div>
              </div>
              <ul class="commodity-information fl">
                <li class="commodity-infos">
                  <div class="tit">{{ title ? title : '交付物详情标签' }}</div>
                  <!-- <div class="tit" v-if="detail.type0[1]">{{detail.type0[1].standardData}}</div> -->
                  <ul class="infos clearfix">
                    <li class="in fl" v-if="detail.type0.length">
                      <div class="width30" v-for="(type, ind) in getShowTag(detail.type0)" :key="ind">
                        <span class="attribute-l">{{ type.standardName }}：</span>
                        <span class="attribute-r">
                          <img v-if="isPic(type.standardData)" style="position: relative; height: 22px; top: 6px" :src="type.standardData" />
                          {{ !isPic(type.standardData) ? type.standardData : '' }}
                        </span>
                      </div>
                    </li>
                    <li class="in fl" v-if="detail.type1.length">
                      <div class="width30" v-show="ind < 6" v-for="(type, ind) in getShowTag(detail.type1)" :key="ind">
                        <span class="attribute-l">{{ type.standardName }}：</span>
                        <span class="attribute-r">
                          <img v-if="isPic(type.standardData)" style="position: relative; height: 22px; top: 6px" :src="type.standardData" />
                          {{ !isPic(type.standardData) ? type.standardData : '' }}
                        </span>
                      </div>
                    </li>
                    <li class="in fl" v-if="detail.type2.length">
                      <div class="width30" v-show="ind < 6" v-for="(type, ind) in getShowTag(detail.type2)" :key="ind">
                        <span class="attribute-l">{{ type.standardName }}：</span>
                        <span class="attribute-r">
                          <img v-if="isPic(type.standardData)" style="position: relative; height: 22px; top: 6px" :src="type.standardData" />
                          {{ !isPic(type.standardData) ? type.standardData : '' }}
                        </span>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <right-tab v-show="isPC ? 'true' : showRightMenu" v-if="floorDetailShow.indexOf('right') > -1" :Ind="leftTabInd" :tabActiveType="tabActiveType" :tempNav="tempNavRight" :perNum="tabTopBottomLen" :navHeight="leftAndRightNavHeight" :nav="nodeNavRight" @changeTab="changeFlowTab" />
        </div>
      </template>
      <!-- 十项交付物 -->
      <template v-if="tenBlock">
        <!-- 中机知道 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1)) ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 1 || (newLoftShow == 0 && (iframeShow.indexOf('1') > -1 || (!iframeShow && tagData.indexOf('ext_wz_machine_know') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '1', zhongjiPic, sortTag)"
          @touchstart.stop="touchstarts($event, '1', zhongjiPic, sortTag)"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>
          <div>
            <div class="detail-content" v-if="now == '0' && !types1.length" style="position: relative">
              <div class="d-content" :style="{ padding: rightShowType ? '20px 12px 20px 20px' : '20px 20px 0', width: rightShowType ? '1019px' : '100%', 'box-sizing': 'border-box' }">
                <jinriSwipers v-if="Demonstrations == 'cmwz' || Demonstrations == 'ftgt'" :demonstrations="Demonstrations" :sortTag="[childContentId ? integrationData : [...sortTag, ...zhongjiPic]]" @windowRightMenu="windowRightMenu" @rightFalse="rightShow = false" :Name="Name1"  :ind="'1'"></jinriSwipers>
                <div class="outDiv" v-if="Demonstrations == 'sccp'">
                  <div class="outDic-top">
                    <!-- 左侧轮播图 -->
                    <div :class="{ swiperRight1: swiperR1, swiperDown1: swiperD1, swiperLeft: swiperL1 }" @contextmenu.stop.prevent="" @touchstart.stop="">
                      <div class="thumbs swiper-container" id="oneTop" :class="{ swiperRight2: swiperR1, swiperDown2: swiperD1 }">
                        <ul v-if="zhongjiPic.length" class="clearfix swiper-wrapper chat_img">
                          <li class="fl swiper-slide" v-for="(ite, ind) in zhongjiPic" :key="ind">
                            <ZImage :value="ite.standardData ? ite.standardData : ''" :error-src="require('../assets/image/images/default_media.png')" />
                          </li>
                        </ul>
                        <ul v-else class="clearfix swiper-wrapper">
                          <li class="fl swiper-slide">
                            <ZImage value="" :error-src="require('../assets/image/images/default_media.png')" />
                          </li>
                        </ul>
                      </div>
                      <div :class="{ swiperRight3: swiperR1, swiperDown3: swiperD1 }"></div>
                      <div class="swiperDown" :class="{ swiperRight4: swiperR1, swiperDown4: swiperD1 }">
                        <div class="arrow-left" :class="{ swiperRight: swiperR1, swiperDown: swiperD1 }"></div>
                        <div class="detail-contents swiper-container" id="oneDown" :class="{ swiperRight5: swiperR1, swiperDown5: swiperD1 }">
                          <ul v-if="zhongjiPic.length" class="clearfix swiper-wrapper">
                            <li class="fl swiper-slide" v-for="(ite, ind) in zhongjiPic" :key="ind">
                              <ZImage :value="ite.standardData ? ite.standardData : ''" :error-src="require('../assets/image/images/default_media.png')" />
                            </li>
                          </ul>
                          <ul v-else class="clearfix swiper-wrapper">
                            <li class="fl swiper-slide">
                              <ZImage value="" :error-src="require('../assets/image/images/default_media.png')" />
                            </li>
                          </ul>
                        </div>
                        <div class="arrow-right" :class="{ swiperRight: swiperR1, swiperDown: swiperD1 }"></div>
                      </div>
                    </div>
                    <!-- 右侧文字展示 -->
                    <ul class="specs clearfix chat_img" :style="{ 'margin-left': '20px', 'max-height': '500px', width: isShowMore ? '830px' : '800px', overflow: 'auto' }" v-if="sortTag.length">
                      <div class="textTit" ref="textTit" style="font-size: 24px; color: #333; margin-bottom: 10px">
                        <span>{{ sortTag[0].standardData }}</span>
                        <coupen v-if="sortTag[0].discountTypes == 'give'" :item="sortTag[0]" @getCoupen="getCoupen(sortTag[0].giveHrefUrl)"></coupen>
                        <preferential v-else :items="sortTag[0]"></preferential>
                      </div>
                      <div v-if="publishUserName || publishTime">
                        <span v-if="publishUserName">发布人 ：{{publishUserName}}</span>
                        <span v-if="publishTime" class="time">{{publishTime}}</span>
                      </div>
                      <!-- !(isPic(type.standardData)&& type.fileTypeDetail==2) && type.standardData.length > 21 && type.standardEnName != 'product_experience' ? 'fill' : '', -->
                      <template v-for="(type, index) in filterJCPrice(sortTag)">
                        <li
                          :key="index"
                          :class="[{allWidth:determineWidth}, 'fl',{fill:type.standardData == 'theoneandonlyAddtoCart'}, { shop: type.standardData == 'theoneandonlyAddtoCart' }]"
                          :style="type.standardData == 'theoneandonlyAddtoCart' ? 'border-top:0;' : ''"
                          v-if="labelDisplayed(type.standardEnName, type.standardData) && index > 0 && type.standardEnName != 'productBrief' && ((type.standardEnName != 'productMarking' && !isPrice(type.standardEnName)) || (isPrice(type.standardEnName) && type.standardData))"
                        >
                          <span v-if="type.standardData != 'theoneandonlyAddtoCart'" class="attribute-l fl">{{ type.standardName }}：</span>
                          <span v-if="type.standardData != 'theoneandonlyAddtoCart'" :class="['attribute-r', 'fl',{'productBrief':type.standardEnName == 'productBrief'}]" @click="jumpArea(type, [...zhongjiPic, ...sortTag], sortTag[0].standardData)">
                            <a href="javascript:;" class="upload-pic" v-if="isPic(type.standardData) && type.fileTypeDetail==2">
                              <img class="label-preview" :src="type.standardData" @click="slideshows(type.standardData)" />
                            </a>
                            <span v-else-if="type.standardEnName == 'product_experience'" class="blueColor" @click="openVideo(type.standardData,type.ssoFileName)">
                              {{type.ssoFileName.split('.mp4')[0]}}
                            </span>
                            <!-- <span v-else-if="type.standardEnName == 'xmjcprice'" class="blueColor" @click="openNewPage()">
                              {{type.standardData}}
                            </span> -->
                            <template v-else>
                              {{ allPrice(type.standardEnName) ? formatPrice(type.standardData) : type.standardData }}
                            </template>
                          </span>
                          <span class="shoppingCart" v-if="type.standardData == 'theoneandonlyAddtoCart'">
                            <span class="shoppingCart-r" @click="joinShop(zhongjiPic, [...zhongjiPic, ...sortTag])">加入购物车</span>
                            <span class="shoppingCart-l" @click="toOpenShopping">购物车</span>
                          </span>
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class="outDic-bottom">
                    <ul class="specs clearfix chat_img">
                      <li class="fill fl">
                        <span class="attribute-l fl">{{ filterIntroduction.length && filterIntroduction[0].standardName }}：</span>
                        <span class="attribute-r fl productBrief">
                          <span class="lineHeight" v-html="filterIntroduction.length && filterIntroduction[0].standardData.replace(/\n/g, '</br>')"></span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="jinriswiperDown" v-if="Demonstrations == 'sccp'">
                  <div class="detail-contents">
                    <ul class="clearfix">
                      <template v-for="(ite,ind) in integrationSwiperData">
                        <li :class="['fl', 'swiper-slide',{'swiper-slide-active':ind == chooseInd}]"
                            :key="ind" @click="changeDatas(ite,ind)">
                          <span class="mainTitle">{{ ite.contentName }}</span>
                        </li>
                      </template>
                    </ul>
                  </div>
                  <div class='arrow-right' @click="goToSerialize"></div>
                </div>
                <pinglun :contentId="zhongjiData" :dataType="1"></pinglun>
              </div>
            </div>

            <test v-show="now == '0' && types1.length" :arr="types1" :index="'1'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now != '0' && now != Name1.length - 1" :number="signs" :floor="'1'" :indexs="1" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="sortTag.length > 0 ? sortTag[0].contentId : types1.length && types1[0] && types1[0][0] && types1[0][0].sortTag.length ? types1[0][0].sortTag[0][0].contentId : ''" v-show="now == Name1.length - 1"></pingjia>
          </div>
        </div>
        <!-- 今日资讯 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1)) ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 7 || (newLoftShow == 0 && (iframeShow.indexOf('7') > -1 || (!iframeShow && tagData.indexOf('ext_wz_todays_information') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '7', contents[0], contents[0])"
          @touchstart.stop="touchstarts($event, '7', contents[0], contents[0])"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>

          <div class="detail-content">
            <div v-if="now6 == '0' && !types7.length" style="position: relative">
              <div class="d-content" :style="{ padding: rightShowType ? '20px 12px 20px 20px' : '20px 20px 0', width: rightShowType ? '1019px' : '100%', 'box-sizing': 'border-box' }">
                <jinriSwipers v-if="Demonstrations == 'cmwz' || Demonstrations == 'ftgt'" :demonstrations="Demonstrations" :sortTag="childContentId ? [integrationData] : contents" @windowRightMenu="windowRightMenu" @rightFalse="rightShow = false" :Name="Name6"  :ind="'7'"></jinriSwipers>
                <div class="outDiv" v-if="Demonstrations == 'sccp'">
                  <div style="width: 62%; height: 450px; overflow: auto">
                    <jinriSwipers :sortTag="contents"  :ind="'7'"></jinriSwipers>
                  </div>
                  <ul class="specs base clearfix" style="width: 38%; padding-left: 20px; margin-top: -6px; overflow: auto; height: 450px">
                    <template v-for="(type, index) in filterJCPrice(newsDatas)">
                    <li  style="width: 90%" :key="index" v-if="labelDisplayed(type.standardEnName, type.link) && !(isPrice(type.standardEnName) && !type.link)" :class="[!isPic(type.link) && !isVideo(type.link) && type.link.length > 21 ? 'fill' : '', 'fl']">
                      <span class="attribute-l fl">{{ type.name }}：</span>
                      <span :class="['attribute-r', 'fl']" @click="jumpArea(type, contents[0], newsDatas[0].standardData)" style="word-break: break-all">
                        <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'img', 0)" v-if="isPic(type.link)">
                          <img class="label-preview" :src="type.link" />
                        </a>
                        <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'video', 0)" v-else-if="isVideo(type.link)">
                          <video :src="type.link" webkit-playsinline="true" playsinline="true" @click.stop=""></video>
                        </a>
                        <template v-else-if="!('ssoFileName' in type)">
                          {{ allPrice(type.standardEnName) ? formatPrice(type.link) : type.link }}
                        </template>
                        <a href="javascript:;" class="upload-pic" style="display: flex" v-else @click="caozuoFunc(type.link, 'file', 0)">
                          <div>
                            <img v-if="type.link.indexOf('xlsx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_excle.png')" />
                            <img v-else-if="type.link.indexOf('pptx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_ppt.png')" />
                            <img v-else-if="type.link.indexOf('docx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_word.png')" />
                            <img v-else-if="type.link.indexOf('txt') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_txt.png')" />
                            <ZImage v-else :value="type.link" :error-src="require('../assets/image/images/default_media.png')" />
                          </div>
                          <div style="margin-left: 10px">
                            <span>{{ type.ssoFileName ? type.ssoFileName : type.link }}</span>
                          </div>
                        </a>
                      </span>
                    </li>
                    </template>
                  </ul>
                </div>
                <pinglun :contentId="type6" :dataType="7"></pinglun>
              </div>
            </div>
            <test v-show="now6 == '0' && types7.length" :arr="types7" :index="'7'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now6 != '0' && now6 != Name6.length - 1" :number="signs6" :floor="'7'" :indexs="7" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="newsData.length > 0 ? newsData[0].contentId : types7.length && types7[0] && types7[0][0] && types7[0][0].sortTag.length ? types7[0][0].sortTag[0][0].contentId : ''" v-show="now6 == Name6.length - 1"></pingjia>
          </div>
        </div>
        <!-- 抖变视界 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1))  ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 2 || (newLoftShow == 0 && (iframeShow.indexOf('2') > -1 || (!iframeShow && tagData.indexOf('ext_wz_hundreds_impression') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '2', pics[0], sortTagBJ)"
          @touchstart.stop="touchstarts($event, '2', pics[0], sortTagBJ)"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>

          <div class="swiper">
            <div v-if="now1 == '0' && !types2.length" class="detail-content" style="position: relative">
              <div class="d-content" :style="{ padding: rightShowType ? '20px 12px 20px 20px' : '20px 20px 0', width: rightShowType ? '1019px' : '100%', 'box-sizing': 'border-box' }">
                <jinriSwipers v-if="Demonstrations == 'cmwz' || Demonstrations == 'ftgt'" :demonstrations="Demonstrations" :sortTag="[childContentId ? integrationData : [...sortTagBJ, ...pics]]" @windowRightMenu="windowRightMenu" @rightFalse="rightShow = false" :Name="Name2"  :ind="'2'"></jinriSwipers>
                <div class="outDiv" v-if="Demonstrations == 'sccp'">
                  <div :class="{ swiperRight1: swiperR2, swiperDown1: swiperD2, swiperLeft: swiperL2 }">
                    <div class="thumbs swiper-container" id="twoTop" :class="{ swiperRight2: swiperR2, swiperDown2: swiperD2 }">
                      <ul class="clearfix swiper-wrapper chat_img" v-if="pics.length">
                        <li class="fl swiper-slide" v-for="(ite, ind) in pics" :key="ind">
                          <ZImage :value="ite.standardData ? ite.standardData : ''" :error-src="require('../assets/image/images/default_media.png')" />
                        </li>
                      </ul>
                      <ul v-else class="clearfix swiper-wrapper">
                        <li class="fl swiper-slide">
                          <ZImage value="" :error-src="require('../assets/image/images/default_media.png')" />
                        </li>
                      </ul>
                    </div>
                    <div :class="{ swiperRight3: swiperR2, swiperDown3: swiperD2 }"></div>
                    <div class="swiperDown" :class="{ swiperRight4: swiperR2, swiperDown4: swiperD2 }">
                      <div class="arrow-left" :class="{ swiperRight: swiperR2, swiperDown: swiperD2 }"></div>
                      <div class="detail-contents swiper-container" id="twoDown" :class="{ swiperRight5: swiperR2, swiperDown5: swiperD2 }">
                        <ul class="clearfix swiper-wrapper" v-if="pics.length">
                          <li class="fl swiper-slide" v-for="(ite, ind) in pics" :key="ind">
                            <ZImage :value="ite.standardData ? ite.standardData : ''" :error-src="require('../assets/image/images/default_media.png')" />
                          </li>
                        </ul>
                        <ul v-else class="clearfix swiper-wrapper">
                          <li class="fl swiper-slide">
                            <ZImage value="" :error-src="require('../assets/image/images/default_media.png')" />
                          </li>
                        </ul>
                      </div>
                      <div class="arrow-right" :class="{ swiperRight: swiperR2, swiperDown: swiperD2 }"></div>
                    </div>
                  </div>
                  <ul class="specs clearfix" :style="{ 'margin-left': '15px', width: isShowMore ? '830px' : '800px', overflow: 'auto', height: '450px' }" v-if="sortTagBJ.length">
                    <div class="textTit" ref="textTit" v-show="false" style="font-size: 24px; color: #333; margin-bottom: 10px">
                      <span>{{ sortTagBJ[0].standardData }}</span>
                      <preferential :items="sortTagBJ[0]"></preferential>
                    </div>
                    <template v-for="(type, index) in filterJCPrice(sortTagBJ)">
                      <li  :key="index" v-if="labelDisplayed(type.standardEnName, type.standardData) && index > 0 && !(isPrice(type.standardEnName) && !type.standardData)" :class="[!isPic(type.standardData) && type.standardData.length > 21 ? 'fill' : '', 'fl']">
                        <span class="attribute-l fl">{{ type.standardName }}：</span>
                        <span :class="['attribute-r', 'fl']" @click="jumpArea(type, [...pics, ...sortTagBJ], sortTagBJ[0].standardData)" style="word-break: break-all">
                          <a href="javascript:;" class="upload-pic" v-if="isPic(type.standardData)">
                            <img class="label-preview" :src="type.standardData" @click="slideshows(type.standardData)" />
                          </a>
                          <template v-else>
                            {{ allPrice(type.standardEnName) ? formatPrice(type.standardData) : type.standardData }}
                          </template>
                        </span>
                      </li>
                    </template>
                  </ul>
                </div>
                <pinglun :contentId="baijiaData" :dataType="2"></pinglun>
              </div>
            </div>
            <test v-show="now1 == '0' && types2.length" :arr="types2" :index="'2'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now1 != '0' && now1 != Name2.length - 1" :number="signs1" :floor="'2'" :indexs="2" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="sortTagBJ.length > 0 ? sortTagBJ[0].contentId : types2.length && types2[0] && types2[0][0] && types2[0][0].sortTag.length ? types2[0][0].sortTag[0][0].contentId : ''" v-show="now1 == Name2.length - 1"></pingjia>
          </div>
        </div>
        <!-- ZJ直播 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1)) ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 6 || (newLoftShow == 0 && (iframeShow.indexOf('6') > -1 || (!iframeShow && tagData.indexOf('ext_wz_screen_live') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '6')"
          @touchstart.stop="touchstarts($event, '6')"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>

          <div>
            <div v-show="now5 == '0' && !types6.length" style="display: flex">
              <div class="detail-content" :style="[{ width: '100%' }, isShowMore ? { border: '1px solid #ddd' } : {}]">
                <iframe id="liveFrame" name="liveFrame" style="width: 100%; height: 772px" allow="fullscreen;camera;microphone" class="archArch-box" :src="liveBroadcast" frameborder="0"></iframe>
              </div>
            </div>
            <test v-show="now5 == '0' && types6.length" :arr="types6" :index="'6'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now5 != '0' && now5 != Name4.length - 1" :number="signs5" :floor="'6'" :indexs="6" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="tongping.length > 0 ? tongping[0].contentId : types6.length && types6[0] && types6[0][0] && types6[0][0].sortTag.length ? types6[0][0].sortTag[0][0].contentId : ''" v-show="now5 == Name4.length - 1"></pingjia>
          </div>
        </div>

        <!-- AI设备 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1)) ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 10 || (newLoftShow == 0 && (iframeShow.indexOf('10') > -1 || (!iframeShow && tagData.indexOf('ext_wz_ai_set') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '10', AIshebeiData[0], AIshebeiData[0])"
          @touchstart.stop="touchstarts($event, '10', AIshebeiData[0], AIshebeiData[0])"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>

          <div class="detail-content">
            <div v-if="now9 == '0' && !types10.length" style="position: relative">
              <div class="d-content" :style="{ padding: rightShowType ? '20px 12px 20px 20px' : '20px 20px 0', width: rightShowType ? '1019px' : '100%', 'box-sizing': 'border-box' }">
                <jinriSwipers v-if="Demonstrations == 'cmwz' || Demonstrations == 'ftgt'" :demonstrations="Demonstrations" :sortTag="childContentId ? integrationData : AIshebeiData" @windowRightMenu="windowRightMenu" @rightFalse="rightShow = false" :Name="Name9"  :ind="'10'"></jinriSwipers>
                <div class="outDiv" v-if="Demonstrations == 'sccp'">
                  <div style="width: 62%; height: 450px; text-align: center">
                    <baijiaSwipers :sortTag="AIsortTag" :ind="'10'"></baijiaSwipers>
                  </div>
                  <ul class="specs clearfix" style="width: 38%; height: 450px; margin-left: 20px; overflow: auto">
                    <template v-for="(type, index) in filterJCPrice(AIsortTag)">
                      <li
                        style="width: 90%"
                        :key="index"
                        v-if="labelDisplayed(type.standardEnName, type.link) && !(isPic(type.link) || isVideo(type.link) || isFile(type.link) || (isPrice(type.standardEnName) && !type.link))"
                        :class="[!isPic(type.link) && !isVideo(type.link) && type.link.length > 21 ? 'fill' : '', 'fl']"
                      >
                        <span class="attribute-l fl">{{ type.name }}：</span>
                        <span :class="['attribute-r', 'fl']" @click="jumpArea(type, AIshebeiData[0], AIsortTag[0].standardData)" style="word-break: break-all">
                          <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'img', 2)" v-if="isPic(type.link)">
                            <img class="label-preview" :src="type.link" />
                          </a>
                          <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'video', 2)" v-else-if="isVideo(type.link)">
                            <video :src="type.link" webkit-playsinline="true" playsinline="true" @click.stop=""></video>
                          </a>
                          <template v-else-if="!('ssoFileName' in type)">
                            {{ allPrice(type.standardEnName) ? formatPrice(type.link) : type.link }}
                          </template>
                          <a href="javascript:;" class="upload-pic" style="display: flex" v-else @click="caozuoFunc(type.link, 'file', 2)">
                            <div>
                              <img v-if="type.link.indexOf('xlsx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_excle.png')" />
                              <img v-else-if="type.link.indexOf('pptx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_ppt.png')" />
                              <img v-else-if="type.link.indexOf('docx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_word.png')" />
                              <img v-else-if="type.link.indexOf('txt') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_txt.png')" />
                              <ZImage v-else :value="type.link" :error-src="require('../assets/image/images/default_media.png')" />
                            </div>
                            <div style="margin-left: 10px">
                              <span>{{ type.ssoFileName ? type.ssoFileName : type.link }}</span>
                            </div>
                          </a>
                        </span>
                      </li>
                    </template>
                  </ul>
                </div>
                <pinglun :contentId="AIshebeiData" :dataType="10"></pinglun>
              </div>
              <!-- 右侧转发人 -->
              <!-- <rightForward :contentId='AIshebeiData'
                            v-show="rightShowType"
                            :name="10"></rightForward> -->
            </div>
            <test v-show="now9 == '0' && types10.length" :arr="types10" :index="'10'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now9 != '0' && now9 != Name9.length - 1" :number="signs9" :floor="'10'" :indexs="10" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="AIsortTag.length > 0 ? AIsortTag[0].contentId : types10.length && types10[0] && types10[0][0] && types10[0][0].sortTag.length ? types10[0][0].sortTag[0][0].contentId : ''" v-show="now9 == Name9.length - 1"></pingjia>
          </div>
        </div>
        <!-- 百家文库 -->
        <div
          class="commodity-detail"
          :style="(hideTop || (window.location.href.indexOf('showMore') > -1)) ? 'border:none;margin:0' : ''"
          v-if="newLoftShow == 8 || (newLoftShow == 0 && (iframeShow.indexOf('8') > -1 || (!iframeShow && tagData.indexOf('ext_wz_hundreds_library') > -1)))"
          @contextmenu.stop.prevent="windowRightMenu($event, '8', baijiawenkuData[0], baijiawenkuData[0])"
          @touchstart.stop="touchstarts($event, '8', baijiawenkuData[0], baijiawenkuData[0])"
          @touchmove="touchmoves()"
          @touchend="touchends()"
        >
          <ul class="titles clearfix" v-show="!hideTop">
            <li class="curr">
              <a href="javascript:;">{{ name }}</a>
            </li>
          </ul>

          <div class="detail-content" style="padding: 0px">
            <div v-if="now7 == '0' && !types8.length" style="overflow: auto; position: relative">
              <div class="d-content" :style="{ padding: rightShowType ? '20px 12px 20px 20px' : '20px 20px 0', width: rightShowType ? '1019px' : '100%', 'box-sizing': 'border-box' }">
                <jinriSwipers v-show="Demonstrations == 'cmwz' || Demonstrations == 'ftgt'" :demonstrations="Demonstrations" :sortTag="childContentId ? integrationData : baijiawenkuData" @windowRightMenu="windowRightMenu" @rightFalse="rightShow = false" :Name="Name7"  :ind="'8'"></jinriSwipers>
                <div class="outDiv" v-show="Demonstrations == 'sccp'">
                  <div style="width: 62%; height: 450px; text-align: center">
                    <baijiaSwipers :sortTag="baijiawenkuData" :ind="'8'"></baijiaSwipers>
                  </div>
                  <ul class="specs clearfix" style="width: 38%; height: 450px; margin-left: 20px; overflow: auto">
                    <template v-for="(type, index) in filterJCPrice(articleList)">
                      <li
                        style="width: 90%"
                        :key="index"
                        v-if="labelDisplayed(type.standardEnName, type.link) && !(isPic(type.link) || isVideo(type.link) || isFile(type.link) || (isPrice(type.standardEnName) && !type.link))"
                        :class="[!isPic(type.link) && !isVideo(type.link) && type.link.length > 21 ? 'fill' : '', 'fl']"
                      >
                        <span class="attribute-l fl">{{ type.name }}：</span>
                        <span :class="['attribute-r', 'fl']" @click="jumpArea(type, baijiawenkuData[0], articleList[0].standardData)" style="word-break: break-all">
                          <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'img', 0)" v-if="isPic(type.link)">
                            <img class="label-preview" :src="type.link" />
                          </a>
                          <a href="javascript:;" class="upload-pic" @click="caozuoFunc(type.link, 'video', 0)" v-else-if="isVideo(type.link)">
                            <video :src="type.link" webkit-playsinline="true" playsinline="true" @click.stop=""></video>
                          </a>
                          <template v-else-if="!('ssoFileName' in type)">
                            {{ allPrice(type.standardEnName) ? formatPrice(type.link) : type.link }}
                          </template>
                          <a href="javascript:;" class="upload-pic" style="display: flex" v-else @click="caozuoFunc(type.link, 'file', 0)">
                            <div>
                              <img v-if="type.link.indexOf('xlsx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_excle.png')" />
                              <img v-else-if="type.link.indexOf('pptx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_ppt.png')" />
                              <img v-else-if="type.link.indexOf('docx') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_word.png')" />
                              <img v-else-if="type.link.indexOf('txt') > -1" class="label-preview" :src="require('../assets/image/images/icons/icon_file_txt.png')" />
                              <ZImage v-else :value="type.link" :error-src="require('../assets/image/images/default_media.png')" />
                            </div>
                            <div style="margin-left: 10px">
                              <span>{{ type.ssoFileName ? type.ssoFileName : type.link }}</span>
                            </div>
                          </a>
                        </span>
                      </li>
                    </template>
                  </ul>
                </div>
                <pinglun :contentId="baijiawenkuData" :dataType="8"></pinglun>
              </div>
            </div>
            <test v-show="now7 == '0' && types8.length" :arr="types8" :index="'8'" @emit="windowRightMenu"></test>
            <smartAppSameScreenShow v-if="now7 != '0' && now7 != Name7.length - 1" :number="signs7" :floor="'8'" :indexs="8" :blockData="blockData"></smartAppSameScreenShow>
            <pingjia :contentId="articleList.length > 0 ? articleList[0].contentId : types8.length && types8[0] && types8[0][0] && types8[0][0].sortTag.length ? types8[0][0].sortTag[0][0].contentId : ''" v-show="now7 == Name7.length - 1"></pingjia>
          </div>
        </div>
      </template>
      <!-- 新添加楼层 -->
      <template v-if="newStandardShow && !newLoftShow">
        <div v-for="(ite, ind) in newStandardShow" :key="ind" class="commodity-detail">
          <floor :arr="ite" :index="(ind + 11).toString()" :num="num" @changeSign="changeSign" :blockData="blockData" @emitp="update" @emit="windowRightMenu"></floor>
        </div>
      </template>
      <!-- 添加框 -->
      <div v-if="($store.state.isManage == 1 || $store.state.isManage == 3) && !newLoftShow">
        <div id="create" v-if="createSrc">
          <iframe :src="createSrc" frameborder="0" height="100%" width="100%"></iframe>
        </div>
        <div id="bottom" @click="bottom()" v-else>
          <img class="first" :src="require('../assets/image/images/block_add.png')" alt="" />
          <img class="secont" :src="require('../assets/image/images/block_add_curr.png')" alt="" />
        </div>
      </div>

      <template v-for="frame in deviceFrameList">
        <div class="commodity-detail" :key="frame.blockId" v-show="frame.detailFloor != 4 ? true : $store.state.isManage == 3" v-if="frame.detailUrl && !newLoftShow">
          <ul class="titles clearfix">
            <li class="curr">
              <a href="javascript:;">{{ frame.detailNameNew }}</a>
            </li>
          </ul>
          <div class="detail-content" style="padding: 0px">
            <iframe style="width: 100%; height: 560px" allow="fullscreen;camera;microphone" :src="frame.detailUrl" frameborder="0"></iframe>
          </div>
        </div>
      </template>
      <!--框架iframe-->
    </div>
    <!-- <div class="right-menu"
         @mousedown.stop=""
         @touchstart.stop=""
         v-show="rightShow&&rightMenus"
         :style="{top:`${rMenuPos.top}px`,left:`${rMenuPos.left}px`}">
      <el-cascader-panel @expand-change="handleExpandChange"
                         :props="{ expandTrigger: 'hover', label:'menuName', value:'childmenu',children:'children' }"
                         :options="rightContent">
        <li slot-scope="{data}"
            :title="data.menuName"
            @mousedown.stop="liNewHoverFun(data)"
            @touchstart.stop="liNewHoverFun(data)"
            @mouseenter="liNewHoverFunEnter(data)">
          <span></span>
          <span>{{data.menuName}}</span>
        </li>
      </el-cascader-panel>
    </div> -->
    <div class="right-menu-video" v-if="rightShowVideo" :style="{ top: `${rMenuPos.top}px`, left: `${rMenuPos.left}px` }">
      <div class="fullScreen" @click="videoScreen()">开启全屏</div>
    </div>
  </div>
</template>
<script>
import { menu, appendMenu, authLoginMenu } from '../menu.js'
import NavTop from '../components/NavTop.vue'
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import topTab from '../components/floorBlock/control/topTab.vue'
import leftTab from '../components/floorBlock/control/leftTab.vue'
import rightTab from '../components/floorBlock/control/rightTab.vue'
import ZImage from '../components/ZImage.vue'
import news from '../components/floorBlock/news.vue'
import detailMenu from '../components/floorBlock/control/detailMenu.vue'
import smartAppSameScreenShow from '../components/floorBlock/detailShow.vue'
import jinriShow from '../components/floorBlock/jinriShowContent.vue'
import topButton from '../components/floorBlock/topChangeButton.vue'
import pingjia from '../components/floorBlock/xiangguanpingjia.vue'
import pinglun from '../components/flowDetail/pinglun.vue'
import test from './test.vue'
import floor from './Floor.vue'
import Bus from '../bus.js'
import jinriSwipers from '../components/flowDetail/jinrizixunSwipers.vue'
import baijiaSwipers from '../components/flowDetail/baijiawenkuSwipers.vue'
import rightForward from '../components/newFlowDetail/rightForward.vue'
import preferential from '../components/preferential.vue'
import coupen from '../components/coupon.vue'
import moreStorage from '../components/flowDetail/moreStorage.vue'

export default {
  name: 'newflowDetail',
  props: {
    numb: Number,
    name: String,
    showName: Array,
    blockData: Object,
    publish:Object
  },
  components: {
    Header,
    Footer,
    NavTop,
    topTab,
    leftTab,
    rightTab,
    news,
    ZImage,
    detailMenu,
    smartAppSameScreenShow,
    jinriShow,
    topButton,
    pingjia,
    test,
    floor,
    jinriSwipers,
    baijiaSwipers,
    pinglun,
    rightForward,
    preferential,
    moreStorage,
    coupen
  },
  data() {
    return {
      publishUserName:this.getQuery('publishUserName'),
      publishTime:this.getQuery('publishTime'),
      chooseInd:0,
      integrationSwiperData:[{contentName:''}],
      isShowMore: this.getQuery('showMore'),
      showContent: [{ herfUrl: '', notGive: [] }],
      window: window,
      meetingId: this.getQuery('meetingId'),
      communicationId: this.getQuery('communicationId'),
      caozuoIframe: '',
      // rightShowType: this.getQuery('isYyz') == 1 ? true : false,
      rightShowType: false,
      zhongjiData: [],
      baijiaData: [],
      doubianData: [],
      AIshebeiData: [],
      caozuopeixunData: [],
      baijiawenkuData: [],
      videoData: {},
      rightType: this.$store.state.rightType,
      newLoftShow: 1,
      timeOutEvent: 0,
      signs: '',
      signs1: '',
      signs2: '',
      signs3: '',
      signs4: '',
      signs5: '',
      signs6: '',
      signs7: '',
      signs8: '',
      signs9: '',
      redirectUrl: '',
      createSrc: '',
      newStandardShow: [],
      types1: [],
      types2: [],
      types3: [],
      types4: [],
      types5: [],
      types6: [],
      types7: [],
      types8: [],
      types9: [],
      types10: [],
      numVideo: 0,
      swiperR1: false,
      swiperR2: false,
      swiperR3: false,
      swiperL1: false,
      swiperL2: false,
      swiperL3: false,
      swiperD1: true,
      swiperD2: true,
      swiperD3: true,
      direction1: 'horizontal',
      direction2: 'horizontal',
      direction3: 'horizontal',
      sortTagBJ: [],
      inds: 0,
      type6: '',
      content: '',
      contents: [],
      contentTotal: [],
      zhongjiPic: [],
      showTopPic: '',
      showDetail: [],
      detailShow: true,
      tongping: '',
      num: '',
      doubianContent: '',
      rightShowVideo: '',
      pics: [],
      screenLive: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=tongpingzhibo' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=tongpingzhibo' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=tpzbdianshang' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=tongpingzhibokhhj' }
      ],
      zhongjizhidao: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=zhongjizhidao' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=zhongjizhidao' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=zjzdpingtai' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=zjzdhuojia' }
      ],
      todaysInformatio: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=jinrizixun' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=jinrizixun' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=jrzxkjqy' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=jrzxkhhj' }
      ],
      shake_variable_horizon: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=doubianshijie' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=doubianshijie' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=dbsjcs' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=dbsjkhhj' }
      ],
      baijiayinxiang: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=baijiayinxiang' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=baijiayinxiang' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=pingmianguanggao' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=baijiayinxiangkhhj' }
      ],
      baijiawenku: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=baijiawenku' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=baijiawenku' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=bjwkgl' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=bjwkkhhj' }
      ],
      caozuopeixun: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=caozuopeixun' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=caozuopeixun' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=pingtaichanpin1' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=caozuopeixunkhhj' }
      ],
      aishebei: [
        { name: '社会化公有云', url: 'https://520emv.com/uoqid/?appId=aisbzsptsjlr' },
        { name: '公有云', url: 'https://520emv.com/uoqid/?appId=aisbzsptsjlr' },
        { name: '私有云', url: 'https://520emv.com/uoqid/?appId=aisbznkzwz' },
        { name: '客户货架', url: 'https://520emv.com/uoqid/?appId=aisbkhhjzspt' }
      ],
      sign: false,
      comShow: false,
      now: '0',
      now1: '0',
      now2: '0',
      now3: '0',
      now4: '0',
      now5: '0',
      now6: '0',
      now7: '0',
      now8: '0',
      now9: '0',
      rMenuPos: {
        left: 0,
        top: 0
      },
      rightShow: false,
      flowShow: false,
      tabInd: 0,
      alikeList: [],
      blockTags: [],
      detail: {
        type0: [],
        type1: [],
        type2: [],
        type3: []
      },
      rightMenus: null,
      title: '',
      picture: '',
      floorDetailShow: '',
      pathArr: [],
      showLeftMenu: false,
      showRightMenu: false,
      showLeftMenu2: false,
      showRightMenu2: false,
      refeshflag: false,
      leftAndRightNavHeight: 0,
      tabTopBottomLen: 0,
      tabLeftRightLen: 0,
      leftTabInd: -1,
      tabActiveType: 'up',
      tempNavTop: [],
      tempNavLeft: [],
      tempNavRight: [],
      nodeNavTop: [],
      nodeNavLeft: [],
      nodeNavRight: [],
      originItem: null,
      messages: [],
      requiredMsgs: [],
      imglist: [
        { id: 'a1', url: 'http://cms.520emv.com/cme-sso-app/showimg/491367672882171904.png' },
        { id: 'a2', url: 'http://cms.520emv.com/cme-sso-app/showimg/496446170059542528.png' },
        { id: 'a3', url: 'http://cms.520emv.com/cme-sso-app/showimg/491367672882171904.png' },
        { id: 'a4', url: 'http://cms.520emv.com/cme-sso-app/showimg/491367672882171904.png' },
        { id: 'a5', url: 'http://cms.520emv.com/cme-sso-app/showimg/496446170059542528.png' },
        { id: 'a6', url: 'http://cms.520emv.com/cme-sso-app/showimg/491367672882171904.png' }
      ],
      showMask: false,
      iframeShow: '',
      mp4Src: '',
      article: '',
      articleList: [],
      excellsList: [],
      excells: [],
      pdfSrc: '',
      arcSrc: '',
      newsData: [],
      newsDatas: [],
      isDevice: false,
      deviceFrameList: [],
      HaveUrl: [],
      sortTag: [],
      oldStandardShow: false,
      tenBlock: false,
      AIsortTag: [],
      hostname: true,
      Name1: [],
      Name2: [],
      Name3: [],
      Name4: [],
      Name5: [],
      Name6: [],
      Name7: [],
      Name8: [],
      Name9: [],
      Name10: [],
      identification: '',
      isYyz: '',
      Demonstrations: '',
      floorType: this.getQuery('floorflowId'),
      parameter: '0',
      blueContent: [],
      hideTop: this.getQuery('hideTop'),
      integrationData:[],
      childContentId:this.getQuery('childContentId')
    }
  },
  computed: {
    liveBroadcast() {
      var wxud = this.$store.state.isLogin ? '' : (localStorage.getItem('wxud') || ''),isCharge=this.getQuery('isCharge'),currCommunicationId= this.getQuery('communicationId') ? this.getQuery('communicationId') : '';
      var url =
        this.$store.state.baseURL + '/meeting-tool-web/sso/live/index' + (this.$store.state.isLogin && this.getCookie('cmeAppToken') ? '?cmeAppToken=' + this.getCookie('cmeAppToken') + '&' : '?') + 'currCommunicationId=' + currCommunicationId + '&takeGoods=1&platId=' + window.$pfId + '&wxud=' + wxud
      switch (isCharge){
        case "1" :
          url = this.$store.state.baseURL + '/meeting-tool-web/communication/list?communicationType=186&takeGoods=1&currCommunicationId=' + currCommunicationId + '&platId=' + window.$pfId + '&wxud=' + wxud;
          break
        case "2" :
          url = this.$store.state.baseURL + '/meeting-tool-web/sso/live/index?takeGoods=1&isCharge=2&isScreen=screenPosition&platId=' + window.$pfId + '&currCommunicationId=' + currCommunicationId + '&wxud=' + wxud
          break
        case "3" :
          url = this.$store.state.baseURL + '/meeting-tool-web/sso/live/index?communicationType=186&takeGoods=1&currCommunicationId=' + currCommunicationId + '&platId=' + window.$pfId + '&wxud=' + wxud + '&isCharge=3' 
          break
      }
      return url
    },
    isPC() {
      if (window.innerWidth > 768) {
        return true
      } else {
        return false
      }
    },
    filterIntroduction(){
      
      return this.sortTag.filter((tag) => tag.standardEnName == 'productBrief')
    },
    determineWidth(){
      return this.$store.state.winWidth < 768
    },
    tagData() {
      return this.$store.state.tagData
    },
    // tempNav(){
    //     return this.$store.state.detailNav;
    // },
    jinriShow() {
      return this.getQuery('jinriShow')
    },
    rightContent() {
      return ['qualification-honor', 'library', 'biz-circle', 'customer-alliance', 'media-scene'].includes(this.getQuery('floorflowId')) ? this.rightMenus.filter((tag) => !(tag.menuName == '加入购物车' || tag.menuName == '购物车' || tag.menuName == '订单管理' || tag.menuName == '操作工具')) : this.rightMenus
    }
  },
  watch: {
    floorDetailShow: function (tabShow) {
      var tableft = tabShow.indexOf('left') > -1
      var tabright = tabShow.indexOf('right') > -1

      // var tabbottom = tabShow.indexOf('down')>-1;
      var tabtop = tabShow.indexOf('up') > -1

      var preNum = 5
      var Len = 0
      var tbLen = 0
      if (tableft || tabright) {
        Len = 1
        preNum = 4
        if (tableft && tabright) {
          Len = 2
          preNum = 3
        }
      }
      if (tabtop) {
        tbLen = 1
        // if(tabbottom && tabtop){
        //     tbLen = 2;
        // }
      }

      if (window.innerWidth < 768) {
        tbLen = 0
        Len = 0
      }

      this.preNum = preNum
      this.tabLeftRightLen = Len
      this.tabTopBottomLen = tbLen
    },
    'detail.type3': {
      handler: function () {
        let hei = 0
        let _this = this
        this.$nextTick(() => {
          if (_this.$refs.gallerysss) {
            hei = _this.$refs.gallerysss.offsetHeight
            _this.leftAndRightNavHeight = hei + 63
          }
        })
      },
      deep: true
    },
    showName: function (val) {
      this.pushShowName(val)
    },
    numb: function (val) {
      switch (parseInt(this.getQuery('dataType'))) {
        case 1:
          this.now = val
        case 2:
          this.now1 = val
        case 3:
          this.now2 = val
        case 4:
          this.now3 = val
        case 5:
          this.now4 = val
        case 6:
          this.now5 = val
        case 7:
          this.now6 = val
        case 8:
          this.now7 = val
        case 9:
          this.now8 = val
        case 10:
          this.now9 = val
      }
    },
    publish: function (val,newVal) {
      console.log(val,newVal);
      
      if(!this.publishUserName){
        this.publishUserName = val.userName
      }
      if(!this.publishTime){
        this.publishTime = val.submitTime
      }
    },
    '$store.state.userInfo': function (val) {
      if (val && this.getQuery('dataType') == 2 && this.numb == 0) {
        this.IMInit(val.userId, val.trueName, this.$contentId)
      }
    }
  },
  mounted() {
    var _this = this
    
    _this.loading()
    if (!_this.$store.state.isLogin && _this.getQuery('dataType') == 2 && _this.numb == 0) {
      _this.IMInit(_this.getQuery('localUserId') ? _this.getQuery('localUserId') : localStorage.getItem('wxud'), '游客' + (_this.getQuery('localUserId') ? _this.getQuery('localUserId') : localStorage.getItem('wxud')), _this.$contentId)
    }
    //获取轮播图方向
    _this.getSwiperDir(1)
    //获取上端展示名称
    if (_this.showName.length) {
      _this.pushShowName(_this.showName)
    } else {
      _this.getShowName(1)
    }

    _this.getCheckFrame()
    if (typeof window !== 'undefined') {
      document.addEventListener('click', (e) => {
        if (e.target.className !== 'reply-textarea') {
          _this.sign = false
        }
        if (e.target.className !== 'comments') {
          _this.showCom = false
        }
      })
    }

    _this.pathArr = [
      { name: '首页', flowType: 'flow' },
      { name: '刷新当前页', flowType: 'block' }
    ]
    _this.floorDetailShow = sessionStorage.getItem('floorDetailShow') ? sessionStorage.getItem('floorDetailShow') : ''
    //有openId表示已登录
    // var openId = _this.getCookie('openId');
    // var userType = _this.getCookie('userTypes');
    // _this.rightType = openId ? (userType ? userType : 534) : 531;
    // _this.initRightMenu({
    //   types: _this.rightType,
    //   appId: 'zjsqe',
    //   frameType: 'show',
    //   permitUserId: _this.$store.state.userInfo.userId
    // });

    window.addEventListener('mousedown', (event) => {
      if (event.button == 0) {
        _this.rightShow = false
        _this.flowShow = false
      }
    })
    window.addEventListener('touchstart', (event) => {
      _this.rightShow = false
      _this.flowShow = false
      _this.rightShowVideo = false
    })

    _this.getDetailFloorList(_this.$route.query.blockIds)
    //获取优先级勾选数据
    if (_this.floorDetailShow.indexOf('up') > -1) {
      _this.getDetailFlowAndBlock('detail-up-block')
    }
    if (_this.floorDetailShow.indexOf('left') > -1) {
      _this.getDetailFlowAndBlock('detail-left-block')
    }
    if (_this.floorDetailShow.indexOf('right') > -1) {
      _this.getDetailFlowAndBlock('detail-right-block')
    }
  },
  methods: {
    openNewPage(){
      this.$http
        .get('/zciid-deliverable/jump/config/init-edit.json', {
          contentId: this.$contentId
        })
        .then((res) => {
          console.log(res);
        })
    },
    changeDatas(ite,ind){
      this.chooseInd = ind
    },
    goToSerialize(){},
    labelDisplayed(labelEnname, lableData) {
      var arr = ['brandName','specifications', 'rangeApplication']
      if (arr.includes(labelEnname) && !lableData) {
        return false
      } else {
        return true
      }
    },
    getCoupen(url) {
      if (!this.$store.state.userInfo.userId) {
        this.handleLoginAuth()
        return
      }
      this.openIframe(url, '领券')
    },
    getContent() {
      this.$http
        .get('/zciid-deliverable/coupons/notGive.json', {
          appId: this.$appId,
          productId: this.$contentId
        })
        .then((res) => {
          if (res.state == 1 && res.data) {
            this.showContent = res.data
          }
        })
    },
    //中机知道直接进去购物车
    toOpenShopping() {
      // if (!this.$store.state.userInfo.userId) {
      //   this.handleLoginAuth();
      //   return;
      // }
      // var Str={buttonId: "zciid-jfwk001000000000000guru1628758849476240621",
      // childmenu: "ZNYJTYPT-index-20210812042939-hkUlqQT7",
      // className: "ZNYJTYPT-index-20210812042939-hkUlqQT7",
      // menuName: "购物车",
      // parentmenu: "topMenu",
      // redirectUrl: (decodeURIComponent(this.getQuery('prevTypes')) || this.$store.state.baseURL) +  "/oqmid-pay-tool-web/shop/cart/list?pfId=#pfId",
      // targetType: "openFrame"};
      // this.liNewHoverFun(Str);
      this.handleShopCart();
    },
    //中机知道直接加入购物车
    joinShop(ite, item) {
      if (ite) {
        this.content = ite
      }
      if (item) {
        this.contentTotal = item
      }
      this.joinShopCart(this.content[0].contentId, this.contentTotal, item)
    },
    jumpArea(area, cont, appName) {
      return
      //点击结算功能取消
      if (this.isPrice(area.standardEnName)) {
        var chanpintupian = cont.filter((tags) => tags.standardEnName && tags.standardEnName == 'mainFigure').length ? cont.filter((tags) => tags.standardEnName && tags.standardEnName == 'mainFigure')[0].standardData : cont.filter((tags) => tags.fileTypeDetail == 2 && tags.standardData)[0].standardData,
          userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : ''
        var url =
          window.location.origin +
          '/zciid-deliverable/api/webapp/app/relation/settlement?appId=' +
          cont.filter((tags) => tags.standardEnName == 'productMarking')[0].standardData +
          '&pricePoints=' +
          area.standardEnName +
          '&wzAppId=' +
          this.getQuery('appId') +
          '&photo=' +
          encodeURIComponent(chanpintupian) +
          '&userId=' +
          userId +
          '&appName=' +
          appName +
          '&contentId=' +
          this.$contentId
        this.openIframe(url, '结算')
      }
    },
    openIframe(url, name) {
      $('.detail-content').hide()
      var html =
        '<div class="layer-show" style="position:relative;height:530px;"><div class="layer-title"><span class="title">' +
        name +
        '</span><span class="layui-layer-setwin"><a href="javascript:;" class="layui-layer-ico layui-layer-close layui-layer-close1"></a></span></div><iframe src="' +
        url +
        '" width="100" height="100" frameborder="0"></iframe></div>'
      $('.detail-content').parent().append(html)
      $(document).on('click', '.layer-show .layui-layer-close', function (e) {
        $('.layer-show').remove()
        $('.detail-content').show()
      })
    },
    openVideo(url, name) {
      var id = url.split('.mp4')[0].split('/').pop(), title = name.split('.mp4')[0]
      this.openIframe('https://520ezj.com/zjstatic/standard/video/odzid.html?id=' + id + '&title=' + title+'&isApp=1',title)
    },
    isPrice(type) {
      return [,'ptxmprice', 'jcxmprice', 'jqrxmprice', 'crhxmprice', 'gcxmprice', 'fjqrccprice', 'jfpzxmprice', 'jfjsxmprice', 'tzxmprice', 'jqrccprice',].includes(type)
    },
    loading() {
      if (this.getQuery('dataType')) {
        //在详情页
        this.newLoftShow = parseInt(this.getQuery('dataType'))
        var displayTypes = this.getQuery('displayTypes')
        if (displayTypes) {
          this.Demonstrations = displayTypes
          if (displayTypes == 'sccp') {
            this.$emit('topShow', true)
          }
          this.getBlockTags(false)
          return
        }
        if (this.getQuery('assetId')) {
          //数据资产详情
          this.getDataAssets()
          this.Demonstrations = 'sccp'
          this.$emit('topShow', true)
          this.tenBlock = true
        } else {
          this.$http
            .get('/zciid-deliverable/api/abduction/getWzStandardTypeByContentId.json', {
              contentId: this.$contentId
            })
            .then((req) => {
              if (req.data) {
                this.parameter = req.data
              }
              this.getBlockTags(false)
              this.getDemon(req)
            })
        }
      } else {
        this.newLoftShow = 0
      }
    },
    getDataAssets() {
      this.$http
        .get('/zciid-deliverable/api/webapp/app/relation/get/dataAssetById.json', {
          assetId: this.getQuery('assetId'),
          pfId: this.getQuery('pfId'),
          pcode: this.getQuery('pcode')
        })
        .then((res) => {
          var types = [
            { standardName: '资产名称', standardData: res.data.assetName, standardEnName: 'appName', appId: this.getQuery('wzAppId'), appName: res.data.pfName },
            { standardData: 'theoneandonlyAddtoCart' },
            // { standardName: '简介', standardData: res.data.intro },
            { standardName: '组织身份', standardData: res.data.pfName },
            { standardName: '资产交易价', standardEnName: 'assetsPrice', standardData: res.data.assetsPrice + '/' + res.data.assetsUnit },
            { standardName: '定期租赁价', standardEnName: 'periodicPrice', standardData: res.data.periodicPrice + '/' + res.data.periodicUnit },
            { standardName: '次数租赁价', standardEnName: 'timesPrice', standardData: res.data.timesPrice + '/' + res.data.timesUnit },
            { standardName: '简介', standardEnName: 'productBrief', standardData: res.data.intro }
          ]
          this.sortTag = this.sortTags(types)
          this.integrationSwiperData = [{contentName:this.sortTag[0].standardData}]
          this.zhongjiPic = [{ standardName: '图片', standardData: this.$store.state.baseURL + `/cme-sso-app/showimg/${JSON.parse(res.data.logo)[0].id}`, fileTypeDetail: 2, appName: res.data.pfName, appId: this.getQuery('wzAppId') }]
        })
    },
    getDemon(req) {
      this.$http
        .get('/zciid-deliverable/api/webapp/quote/get/display/type.json', {
          types: req.data ? 'displayType-media' : 'displayType-general',
          wzAppId: this.getQuery('appId'),
          sixTypes: 'sign' + this.getQuery('dataType')
        })
        .then((res) => {
          if (res.state == 1) {
            this.Demonstrations = res.data
          } else {
            this.Demonstrations = 'sccp'
            // this.Demonstrations = 'cmwz';
          }
          if (res.data != 'cmwz' && res.data != 'ftgt') {
            this.$emit('topShow', true)
          }
          
        })
    },
    liNewHoverFunEnter(data) {
      this.changeData(data)
    },
    handleExpandChange(data) {
      this.rightAreaChange(data, this.rMenuPos.left)
    },
    touchstartVideo(ev, ind, ite) {
      var _this = this
      // 长按事件触发
      clearTimeout(_this.timeOutEvent)
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0
        _this.windowRightMenuVideo(ev, ind, ite)
      }, 400)
      //长按400毫秒
      // e.preventDefault();
    },
    touchstarts(ev, ind, ite, item) {
      var _this = this
      // 长按事件触发
      clearTimeout(_this.timeOutEvent)
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0
        _this.windowRightMenu(ev, ind, ite, item)
      }, 400)
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves() {
      clearTimeout(this.timeOutEvent)
      this.timeOutEvent = 0
    },
    touchends() {
      clearTimeout(this.timeOutEvent)
      if (this.timeOutEvent != 0) {
        // 点击事件
        // this.rightShow = false;
      }
      return false
    },
    bottom() {
      var src = 'https://520emv.com/zciid-deliverable/business/flowSpit/tickDeatilFrame?appId=' + this.getQuery('appId') + '&blockId=' + this.getQuery('blockId')
      this.createSrc = src
    },
    //点击返回更新数据
    update(ind) {
      this.getBlockTags(0)
      Bus.$emit('swiper', ind)
    },

    //获取上端展示名称
    getShowName() {
      var _this = this
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getCheckRightButtonByAppId.json', {
          // appId: this.getQuery('appId'),
          appId: this.getQuery('appId')
          // sign: num
        })
        .then((res) => {
          var data = res.data ? res.data : []
          _this.pushShowName(data)
        })
    },
    pushShowName(data) {
      this.Name1 = JSON.parse(JSON.stringify(data))
      this.Name2 = JSON.parse(JSON.stringify(data))
      this.Name3 = JSON.parse(JSON.stringify(data))
      this.Name4 = JSON.parse(JSON.stringify(data))
      this.Name5 = JSON.parse(JSON.stringify(data))
      this.Name6 = JSON.parse(JSON.stringify(data))
      this.Name7 = JSON.parse(JSON.stringify(data))
      this.Name8 = JSON.parse(JSON.stringify(data))
      this.Name9 = JSON.parse(JSON.stringify(data))
      this.Name10 = JSON.parse(JSON.stringify(data))
      this.Name = true
      this.addName(1)
    },
    //添加各个楼层名称
    addName(num) {
      var _this = this
      switch (num) {
        case 1:
          _this.Name1.unshift({ detailName: '智者说' })
          _this.Name1.push({ detailName: '商品评价' })
          break
        case 2:
          _this.Name2.unshift({ detailName: '抖变视界' })
          _this.Name2.push({ detailName: '商品评价' })
          break
        // case 3:
        //   _this.Name3.unshift({ detailName: '抖变世界' });
        //   _this.Name3.push({ detailName: '商品评价' });
        //   break;
        case 4:
          _this.Name4.unshift({ detailName: '智能直播' })
          _this.Name4.push({ detailName: '商品评价' })
          break
        // case 5:
        //   _this.Name5.unshift({ detailName: 'ZJ同屏' });
        //   _this.Name5.push({ detailName: '商品评价' });
        //   break;
        case 6:
          _this.Name6.unshift({ detailName: '今日资讯' })
          _this.Name6.push({ detailName: '商品评价' })
          break
        case 7:
          _this.Name7.unshift({ detailName: '智能文库' })
          _this.Name7.push({ detailName: '商品评价' })
          break
        // case 8:
        //   _this.Name8.unshift({ detailName: '操作培训' });
        //   _this.Name8.push({ detailName: '商品评价' });
        //   break;
        case 9:
          _this.Name9.unshift({ detailName: 'AI设备' })
          _this.Name9.push({ detailName: '商品评价' })
          break
        case 10:
        // _this.Name10.unshift({ detailName: '同屏体验' });
        // _this.Name10.push({ detailName: '商品评价' });
        // break;
      }
      if (num < 10) {
        _this.addName(num + 1)
      }
    },
    //筛选楼层上端数据
    screening(arr, name) {
      // var name1 = '相关产品', name2 = '商品评价';
      arr.forEach((item) => {
        // if (item.detailSign && item.detailSign == 'xgtj') {
        //   name1 = item.detailName;
        // } else if (item.detailSign && item.detailSign == 'sppj') {
        //   name2 = item.detailName;
        // }
        name.push(item.detailName)
      })
      // name.push({ 'name1': name1, 'name2': name2 });
      return name
    },
    //获取轮播图方向
    getSwiperDir(num) {
      var _this = this
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/detail/getTappByBlockId.json', {
          appId: this.$appId,
          blockId: this.getQuery('blockId'),
          sign: num
        })
        .then((res) => {
          if (res.state == 1) {
            if (num == '1' && res.data.left == '1') {
              _this.swiperL1 = true
              _this.swiperR1 = true
              _this.swiperD1 = false
              _this.direction1 = 'vertical'
            } else if (num == '1' && res.data.left == '2') {
              _this.swiperL1 = false
              _this.swiperR1 = false
              _this.swiperD1 = true
              _this.direction1 = 'horizontal'
            } else if (num == '1' && res.data.left == '3') {
              _this.swiperL1 = false
              _this.swiperR1 = true
              _this.swiperD1 = false
              _this.direction1 = 'vertical'
            } else if (num == '2' && res.data.left == '1') {
              _this.swiperL2 = true
              _this.swiperR2 = true
              _this.swiperD2 = false
              _this.direction2 = 'vertical'
            } else if (num == '2' && res.data.left == '2') {
              _this.swiperL2 = false
              _this.swiperR2 = false
              _this.swiperD2 = true
              _this.direction2 = 'horizontal'
            } else if (num == '2' && res.data.left == '3') {
              _this.swiperL2 = false
              _this.swiperR2 = true
              _this.swiperD2 = false
              _this.direction2 = 'vertical'
            } else if (num == '3' && res.data.left == '1') {
              _this.swiperL3 = true
              _this.swiperR3 = true
              _this.swiperD3 = false
              _this.direction3 = 'vertical'
            } else if (num == '3' && res.data.left == '2') {
              _this.swiperL3 = false
              _this.swiperR3 = false
              _this.swiperD3 = true
              _this.direction3 = 'horizontal'
            } else if (num == '3' && res.data.left == '3') {
              _this.swiperL3 = false
              _this.swiperR3 = true
              _this.swiperD3 = false
              _this.direction3 = 'vertical'
            }
            if (num < 3) {
              _this.getSwiperDir(num + 1)
            }
          }
        })
        .then(() => {
          _this.swiperFn()
        })
    },
    //改变楼层按钮
    changeBut(ind, sign) {
      this.now = ind
      this.signs = sign
      this.identification = sign.detailSign
    },
    changeBut1(ind, sign) {
      this.now1 = ind
      this.signs1 = sign
      this.identification = sign.detailSign
    },
    changeBut2(ind, sign) {
      this.now2 = ind
      this.signs2 = sign
      this.identification = sign.detailSign
    },
    changeBut3(ind, sign) {
      this.now3 = ind
      this.signs3 = sign
      this.identification = sign.detailSign
    },
    changeBut4(ind, sign) {
      this.now4 = ind
      this.signs4 = sign
      this.identification = sign.detailSign
    },
    changeBut5(ind, sign) {
      this.now5 = ind
      this.signs5 = sign
      this.identification = sign.detailSign
    },
    changeBut6(ind, sign) {
      this.now6 = ind
      this.signs6 = sign
      this.identification = sign.detailSign
    },
    changeBut7(ind, sign) {
      this.now7 = ind
      this.signs7 = sign
      this.identification = sign.detailSign
    },
    changeBut8(ind, sign) {
      this.now8 = ind
      this.signs8 = sign
      this.identification = sign.detailSign
    },
    changeBut9(ind, sign) {
      this.now9 = ind
      this.signs9 = sign
      this.identification = sign.detailSign
    },
    //是否为视频文件
    isVideo(val) {
      var ty = false
      if (val && val.indexOf('.mp4') > 0) {
        ty = true
      }
      if (val && val.indexOf('.flv') > 0) {
        ty = true
      }
      if (val && val.indexOf('.rmvb') > 0) {
        ty = true
      }
      if (val && val.indexOf('.wmv') > 0) {
        ty = true
      }
      if (val && val.indexOf('.avi') > 0) {
        ty = true
      }
      if (val && val.indexOf('.mov') > 0) {
        ty = true
      }
      if (val && val.indexOf('.rm') > 0) {
        ty = true
      }
      return ty
    },
    //操作培训点击事件
    caozuoFunc(link, type, num) {
      if (num == '2') {
        this.caozuoType2 = type
        if (type == 'file') {
          this.caozuoSrc2 = `https://${window.location.host}/cme-sso-app/space/transform?id=` + link.split('/')[link.split('/').length - 1].split('.')[0]
        } else {
          this.caozuoSrc2 = link
        }
      } else if (num == '1') {
        this.caozuoType1 = type
        if (type == 'file') {
          this.caozuoSrc1 = `https://${window.location.host}/cme-sso-app/space/transform?id=` + link.split('/')[link.split('/').length - 1].split('.')[0]
        } else {
          this.caozuoSrc1 = link
        }
      } else {
        this.caozuoType = type
        if (type == 'file') {
          this.caozuoSrc = `https://${window.location.host}/cme-sso-app/space/transform?id=` + link.split('/')[link.split('/').length - 1].split('.')[0]
        } else {
          this.caozuoSrc = link
        }
      }
    },
    slideshows(item) {
      var links = []
      if (item.standardData) {
        links.push(item.standardData)
      }
      // this.$router.push({ path: "slideshows", query: { pictures: JSON.stringify(links) } });
      this.routerJump('push', 'slideshows', { pictures: JSON.stringify(links) }, item.name)
    },
    //视频全屏
    videoScreen() {
      var num = this.numVideo
      var link = []
      link.push(this.mp4Src[num].standardData)
      this.$router.push({ path: 'odzid', query: { appId: this.getQuery('appId'), blockId: this.getQuery('blockId'), video: JSON.stringify(link), ind: 0, contentId: this.videoData.contentId, standardId: this.videoData.standardId, dataType: 3 } })
    },
    //预览文件
    previewFile(excell) {
      if (excell.tranId) {
        this.pdfSrc = excell.tranId
      } else {
        this.pdfSrc = excell.link
      }
      this.$router.push({ path: 'odzid', query: { file: JSON.stringify(this.pdfSrc) } })
    },
    swiperFn() {
      if ($('#oneDown').length) {
        var mySwiper = new Swiper('#oneDown', {
          // paginationClickable: true,
          //解决初始化轮播不生效
          observer: true,
          observeParents: true,
          slidesPerView: 5,
          direction: this.direction1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.arrow-right',
            prevEl: '.arrow-left'
          }
        })
        var thumbs = new Swiper('#oneTop', {
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          thumbs: {
            swiper: mySwiper
          }
        })
      }
      if ($('#twoDown').length) {
        var mySwiper = new Swiper('#twoDown', {
          // paginationClickable: true,
          //解决初始化轮播不生效
          observer: true,
          observeParents: true,
          slidesPerView: 5,
          direction: this.direction2,
          spaceBetween: 20,
          navigation: {
            nextEl: '.arrow-right',
            prevEl: '.arrow-left'
          }
        })
        var thumbs = new Swiper('#twoTop', {
          slidesPerView: 1,
          observer: true,
          observeParents: true,
          thumbs: {
            swiper: mySwiper
          }
        })
      }
      // if ($('#threeDown').length) {
      //   var mySwiper = new Swiper('#threeDown', {
      //     // paginationClickable: true,
      //     //解决初始化轮播不生效
      //     observer: true,
      //     observeParents: true,
      //     slidesPerView: 5,
      //     direction: this.direction3,
      //     spaceBetween: 20,
      //     navigation: {
      //       nextEl: '.arrow-right',
      //       prevEl: '.arrow-left',
      //     }
      //   })
      //   var thumbs = new Swiper('#threeTop', {
      //     slidesPerView: 1,
      //     observer: true,
      //     observeParents: true,
      //     thumbs: {
      //       swiper: mySwiper
      //     }
      //   })
      // }
    },
    //控制中机知道显示数量
    toggleDetail(_this) {
      if (!_this) {
        if (this.overNum == 8) {
          this.overNum = 10000
        } else {
          this.overNum = 8
        }
      } else {
        if (this.overNum1 == 8) {
          this.overNum1 = 10000
        } else {
          this.overNum1 = 8
        }
      }
    },
    //评论图片
    handleMask() {
      this.showMask = true
      this.swiperFnScreen()
    },
    showInp() {
      this.sign = !this.sign
    },
    showCom() {
      this.comShow = !this.comShow
    },
    initRightMenu(data) {
      var _this = this
      if (data.flowId && sessionStorage.getItem(data.types + data.flowId)) {
        _this.rightMenus = JSON.parse(sessionStorage.getItem(data.types + data.flowId))
      } else {
        _this.$http.get('/zciid-deliverable/activity/appbutton/getlist.json', data).then((res) => {
          if (res.state == 1) {
            _this.$store.commit('setRightMenuDetail', { menu: res.data, append: '' })
            _this.rightMenus = _this.$store.state.rightMenuDetail
            _this.rightData(data, _this.$store.state.rightMenuDetail)
          } else {
            _this.rightMenus = data.types == 531 ? null : [appendMenu]
          }
        })
      }
    },
    initRightMenus(data) {
      var _this = this
      if (data.blockId && sessionStorage.getItem(data.types + data.blockId)) {
        _this.rightMenus = JSON.parse(sessionStorage.getItem(data.types + data.blockId))
      } else {
        _this.$http.get('/zciid-deliverable/activity/blockbutton/getlist.json', data).then((res) => {
          if (res.state == 1) {
            _this.$store.commit('setRightMenuDetail', { menu: res.data, append: '' })
            _this.rightMenus = _this.$store.state.rightMenuDetail
            _this.rightData(data, _this.$store.state.rightMenuDetail)
          } else {
            _this.rightMenus = [appendMenu]
          }
        })
      }
    },
    //获取设备勾选楼层配置
    getDetailFloorList(bId) {
      var _this = this
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getDetailFloorByBlockId.json', {
          blockId: bId,
          appId: ''
        })
        .then((res) => {
          if (res.state == 1) {
            _this.deviceFrameList = res.data
            var iframe = _this.iframeShow.split(',')
            var iframeShow = [],
              haveUrl = []
            res.data.forEach((item) => {
              if (!item.detailUrl) {
                iframeShow.push(item.detailFloor)
              } else {
                haveUrl.push(item.detailFloor)
              }
            })
            _this.iframeShow = iframeShow.join(',')
            _this.HaveUrl = haveUrl.join(',')
          }
        })
    },
    changeFlowTab(item, param) {
      this.leftTabInd = param.activeTab
      this.tabActiveType = param.tabType

      if (item.flowType == 'block') {
        this.pathArr.splice(2, 1)
        this.getDataByBlock(item, param)
        return false
      }

      var routeItem = this.pathArr[2]
      if (routeItem && routeItem.flowType == 'tagsData' && routeItem.contentId == item.contentId) {
        return false
      }
      // this.$router.replace({ name: "flowDetail", query: { blockId: item.id, sceneId: item.sceneId, contentId: item.contentId, sceneGroupId: item.sceneGroupId } });
      this.routerJump('replace', 'flowDetail', { blockId: item.id, sceneId: item.sceneId, contentId: item.contentId, sceneGroupId: item.sceneGroupId }, item.name)
      if (item.flowType == 'tagsData') {
        this.pathArr.splice(2, 1, item)
      }
      this.getBlockTags(true)
    },
    windowRightMenu(ev, ind, ite, item) {
      window.$nodeId = this.$store.state.nodeId
      window.$floorflowId = this.$store.state.flowId
      window.$contentWzUrl = ite && ite[0].contentWzUrl ? ite[0].contentWzUrl : ''
      window.$releaseId = ite && ite[0].contentId ? ite[0].contentId : ''
      this.isYyz = ite && ite[0].isYyz ? ite[0].isYyz : ''
      this.rMenuPos = this.calculateLocation(ev, this.Demonstrations == 'sccp' ? 85 : 25)
      this.flowShow = false
      this.rightShowVideo = false
      this.rightShow = true
      this.num = ind
      //记录详情页楼层信息，以免触发其他楼层onmessage
      window.$flowDetailNum = ind
      if (ite) {
        //右键获取本条信息
        this.content = ite
      }
      if (item) {
        //右键获取本栏信息
        this.contentTotal = item
      }
      window.$rightLeft.center = {
        contentId: ite[0].contentId,
        standardJson: [...item, ...ite],
        item: ite[0]
      }
      // if (this.rightType == 163 || this.rightType == 532) {
      if (this.rightType == 534 || this.rightType == 532) {
        //自定义楼层使用传过来的appfundType
        if (ind > 10) {
          ind = ite
        }
        // switch (ind) {
        //   case '1':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-70337295153',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '2':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-11665557259',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '3':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-97282890438',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '4':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-90639794295',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '5':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-36777775633',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '6':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-86388954657',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '7':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-22917756921',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '8':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-89474205123',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '9':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-07435817813',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        //   case '10':
        //     this.rightMenus = [{ menuName: "正在加载......" }];
        //     this.initRightMenu({
        //       types: this.rightType,
        //       appId: 'wzjfwzyzspt',
        //       frameType: 'show',
        //       flowId: 'scgid-wzjfwzyzspt-guru-flow-25110623529',
        //       permitUserId: this.$store.state.userInfo.userId,
        //       wzAppId: this.getQuery('appId')
        //     });
        //     break;
        // }
        if (ind == 'header') {
          this.rightMenus = [{ menuName: '正在加载......' }]
          this.initRightMenu({
            types: this.rightType,
            appId: 'zjsqe',
            frameType: 'show',
            flowId: 'wzzid1000938guru-flow-1604056951561184764-quote-zjsqe',
            permitUserId: this.$store.state.userInfo.userId
          })
        }
      }
      this.$emit('windowRight', ev, 'detail')
    },
    windowRightMenuVideo(ev, ind, ite) {
      this.videoData = ite
      if (document.body.style.transform) {
        var scale = document.body.style.transform.slice(6, -1)
        if (ev.pageX + 160 * scale > window.innerWidth) {
          this.rMenuPos.left = (window.innerWidth - 160 * scale) / scale
        } else {
          this.rMenuPos.left = ev.pageX / scale
        }
        this.rMenuPos.top = ev.pageY / scale
      } else {
        var scale = document.body.style.transform.slice(6, -1)
        if (ev.pageX + 160 > window.innerWidth) {
          this.rMenuPos.left = window.innerWidth - 160
        } else {
          this.rMenuPos.left = ev.pageX
        }
        this.rMenuPos.top = ev.pageY
      }
      this.flowShow = false
      this.rightShow = false
      this.rightShowVideo = true
      this.numVideo = ind
    },
    changeSign(sign) {
      this.identification = sign.detailSign
    },
    //配置链接数据替换方法
    replaceDataByWell(url, menu, type, top) {
      let contentId
      if (this.content) {
        contentId = this.content[0].contentId
      } else if (top) {
        contentId = this.$contentId
      }
      let appId = this.$appId
      // let blockId = window.$blockId ? window.$blockId : '';
      let blockId = this.getQuery('blockId') ? this.getQuery('blockId') : ''
      let flowId = ''
      if (menu.childmenu == 'changeBlockType') {
        flowId = window.$floorId ? window.$floorId : ''
      } else {
        flowId = window.$floorflowId && window.$floorflowId.id ? window.$floorflowId.id : ''
      }
      let sign = ''
      if (menu.menuName == '楼层内展示架构配置' || menu.menuName == '楼层上端流程选择' || menu.menuName == '楼层左侧流程选择' || menu.menuName == '楼层右侧流程选择' || menu.menuName == '楼层下端流程选择') {
        sign = this.identification ? this.identification : ''
      } else {
        sign = this.num ? this.num : ''
      }
      let nodeId = window.$nodeId ? window.$nodeId : ''
      let pfId = window.$pfId ? window.$pfId : ''
      let sceneId = window.$sceneId ? window.$sceneId : ''
      let pageType = this.$route.query.diyPageFlowId ? 'diy-page' : 'index'
      let diyPageFlowCode = this.$route.query.code ? this.$route.query.code : ''
      // let contentName = this.$refs.textTit ? this.$refs.textTit.innerText : '';
      let contentName = $('.mainTitle').length ? $('.mainTitle')[0].innerText : $('.textTit span').length ? $('.textTit span')[0].innerText : ''
      //楼层id
      let floorflowId = this.getQuery('floorflowId')
      let releaseId = window.$releaseId ? window.$releaseId : ''
      let dataType = this.getQuery('dataType')
      let userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid')
      let userName = this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : localStorage.getItem('wxud')
      let transmitUrl
      if (window.$contentWzUrl) {
        var array = window.$contentWzUrl.split('=')
        if (array.length > 2 && window.$contentWzUrl.indexOf('id') > -1) {
          array[array.length - 1] = this.isYyz
          contentWzUrlIsYyz = array.join('=')
          transmitUrl = encodeURIComponent(contentWzUrlIsYyz)
        } else {
          transmitUrl = encodeURIComponent(window.$contentWzUrl)
        }
      } else {
        transmitUrl = encodeURIComponent(window.location.href.split('?')[0].replace('flowDetail', 'odzid') + '?appId=' + appId + '&blockId=' + nodeId + '&contentId=' + contentId + '&floorflowId=' + floorflowId + '&dataType=' + dataType + '&isYyz=' + this.isYyz)
      }
      let publishUrl = encodeURIComponent(window.location.href.split('?')[0].replace('flowDetail', 'odzid') + '?id=' + releaseId)
      return url.replace(/(#appId)|(#flowId)|(#blockId)|(#sign)|(#contentId)|(#nodeId)|(#diyPageFlowCode)|(#pfId)|(#sceneId)|(#pageType)|(http:\/\/cms.cmeplaza)|(#pfId)|(#publishUrl)|(#transmitUrl)|(#floorflowId)|(#userId)|(#userName)|(#floorEnName)|(#contentName)|(#dataType)/g, (match) => {
        if (match == '#appId') {
          return appId
        }
        if (match == '#contentName') {
          return contentName
        }
        if (match == '#transmitUrl') {
          return transmitUrl
        }
        if (match == '#userId') {
          return userId
        }
        if (match == '#userName') {
          return userName
        }
        if (match == '#publishUrl') {
          return publishUrl
        }
        if (match == '#floorflowId' || match == '#floorEnName') {
          return floorflowId
        }
        if (match == '#dataType') {
          return dataType
        }
        if (match == '#flowId') {
          if (menu.childmenu == 'changeBlockType') {
            if (type == 'flow-floorStyle') {
              return flowId
            } else {
              return blockId
            }
          } else if (menu.menuName == '楼层内展示架构配置' || menu.menuName == '楼层上端流程选择' || menu.menuName == '楼层左端流程选择' || menu.menuName == '楼层右端流程选择' || menu.menuName == '楼层下端流程选择') {
            return this.getQuery('blockId')
          } else {
            return flowId
          }
        }
        if (match == '#diyPageFlowCode') {
          return diyPageFlowCode
        }
        if (match == '#blockId') {
          return blockId
        }
        if (match == '#sign') {
          return sign
        }
        if (match == '#contentId') {
          return contentId
        }
        if (match == '#nodeId') {
          return nodeId
        }
        if (match == '#pfId') {
          return pfId
        }
        if (match == '#sceneId') {
          return sceneId
        }
        if (match == '#pageType') {
          return pageType
        }
        if (match == 'http://cms.cmeplaza') {
          return 'https://cms.cmeplaza'
        }
      })
    },
    liNewHoverFun(item, top) {
      if (this.$store.state.userInfo.userId) {
        this.addRecord(item.childmenu, item.menuName)
      }
      if (item.menuName == '抓取') {
        startGrab()
        this.rightShow = false
        return
      }
      var _this = this
      var type = window.$changeFlowBlock
      if (type == 'flow') {
        type = 'flow-floorStyle'
      } else {
        type = 'block-floorStyle'
      }
      if (item.targetType == 'none') {
        return false
      }
      //下载
      if (item.childmenu.indexOf('download') > -1) {
        _this.downLoad()
        _this.rightShow = false
        return
      }
      //转发
      if (item.menuName == '转发') {
        _this.retransmission()
        _this.rightShow = false
        return
      }
      //打印
      if (item.childmenu.indexOf('print') > -1) {
        _this.toPrint()
        _this.rightShow = false
        return
      }
      //转发到商圈
      if (item.menuName.indexOf('转发到商圈') > -1) {
        //传递参数z区分右键点击
        Bus.$emit('forwardTo', 8, this.num, 'z', '转发到商圈')
        _this.rightShow = false
        return
      }
      //转发给好友
      if (item.menuName.indexOf('转发给好友') > -1) {
        //传递参数z区分右键点击
        Bus.$emit('forwardTo', 9, this.num, 'z', '转发给好友')
        _this.rightShow = false
        return
      }

      var a = _this.getQuery('blockId')
      if (item.childmenu == 'jfwsxpzx' && (a == null || a == '')) {
        _this.rightShow = false
        return false
      }
      if (item.redirectUrl) {
        //判断如果右键sign没有#时，直接改变sign的值
        if (item.childmenu == 'jfwlcscpz' || item.childmenu == 'jfwlczjkpz' || item.childmenu == 'ZNYJTYPT-index-20210908052046-CunfVUGw') {
          if (item.redirectUrl.indexOf('#') > -1) {
            item.redirectUrl = _this.replaceDataByWell(item.redirectUrl, item, type, top)
          } else {
            var c = item.redirectUrl.split('=')
            c.splice(-1, 1, _this.num)
            var a = c.join('=')
            item.redirectUrl = a
          }
        } else if (item.childmenu == 'winFrameDetailChoose' || item.childmenu == 'ZSZKBYJ-index-20201207095904-JvX6RSQF-quote-ZNYJTYPT' || menu == 'ZSZKBYJ-index-20201207095930-roR4Im2n-quote-ZNYJTYPT' || menu == 'ZSZKBYJ-index-20201207095946-z2gX0Bn0-quote-ZNYJTYPT' || menu == 'xgtjxdxz') {
          if (item.redirectUrl.indexOf('#') > -1) {
            item.redirectUrl = _this.replaceDataByWell(item.redirectUrl, item, type, top)
          } else {
            var c = item.redirectUrl.split('=')
            c.splice(-1, 1, _this.identification)
            var a = c.join('=')
            item.redirectUrl = a
          }
        } else {
          item.redirectUrl = _this.replaceDataByWell(item.redirectUrl, item, type, top)
        }

        if (item.childmenu == 'changeFloorType' || item.childmenu == 'changeBlockType') {
          item.redirectUrl = item.redirectUrl + '&type=' + (_this.$route.query.diyPageFlowId ? 'diy-page' : 'index')
        }
      }
      var left = (window.innerWidth - 900) / 2
      var wH = window.innerHeight / 2 - 100
      // let promoteFirefoxWindowName;
      // if (item.targetType == "opeFrame") {
      if (item.childmenu == 'ZSZKBYJ-index-20201207095556-zTdpF4M1-quote-ZNYJTYPT') {
        item.redirectUrl = item.redirectUrl + `&pfId=${window.$pfId}`
      }
      if (item.childmenu == 'platDeliveryConfig') {
        var nodeId = window.$nodeId
        item.redirectUrl = item.redirectUrl + `&pfId=${window.$pfId}&account=${window.$pfId}`
        if (!nodeId) {
          _this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该节点不是流程块，无工作标签！',
            type: 'warning',
            offset: wH
          })
          return
        }
      }
      if (item.targetType != 'workbench' && item.targetType != 'operateFunc' && item.childmenu != 'addToCart' && item.childmenu != 'addToCart2') {
        // //链接在客户端自定义工作台展示
        // let iframe = document.getElementById("MainFrame");
        // if (iframe) {
        //   iframe.scrollIntoView({ behavior: "smooth" });
        //   iframe.contentWindow.document.getElementById("toolsFrame").setAttribute("src", item.redirectUrl);
        //   // document.getElementById("tongping").scrollIntoView({ behavior: "smooth" });
        // }
        var herfUrls = 'http://' + window.location.host
        switch (item.targetType) {
          case 'opeFrame':
          case 'diy-workbench':
            //链接在客户端自定义工作台展示
            // _this.iframeOpen("toolsFrame", item.redirectUrl);
            layer.open({
              type: 2,
              title: item.menuName,
              closeBtn: 1,
              area: ['100%', '100%'],
              content: item.redirectUrl //iframe的url
            })
            break
          case 'workbench':
            //链接在客户端工作台展示
            // _this.iframeOpen("workFrame", item.redirectUrl);
            layer.open({
              type: 2,
              title: item.menuName,
              closeBtn: 1,
              area: ['100%', '100%'],
              content: item.redirectUrl //iframe的url
            })
            break
          case 'movelink': //动态连接
            var appId = _this.getQuery('appId')
            $.ajax({
              type: 'get',
              url: herfUrls + '/zciid-deliverable/showPlatformStyle/flow/api/getAPPUrlByAppId?appId=' + appId,
              success: function (response) {
                if (response.state == 1) {
                  //链接在客户端自定义工作台展示
                  _this.iframeOpen('toolsFrame', response.data, item.menuName)
                }
              }
            })
            break
          case 'newblank':
            //该链接 带有三宝壳新打开页面处理
            if (item.childmenu == 'hygl-hyglpt') {
              _this.iframeOpen('toolsFrame', item.redirectUrl, item.menuName)
            } else if (item.childmenu == 'jfwtj-ydzmtj') {
              _this.iframeOpen('toolsFrame', item.redirectUrl, item.menuName)
            } else if (item.childmenu == 'ylwz') {
              _this.iframeOpen('toolsFrame', item.redirectUrl, item.menuName)
            } else if (item.childmenu.indexOf('diy-workbench') != -1) {
              _this.iframeOpen('toolsFrame', item.redirectUrl, item.menuName)
            } else {
              // location.href = item.redirectUrl;
              _this.open(item.redirectUrl, '_self')
            }
            break
          case 'alertInfo':
            layer.alert(item.redirectUrl)
            break
          case 'none':
            break
          default:
            break
        }
      }
      if (item.childmenu == 'hymrzsjg') {
        window.location.reload()
      }
      if (item.targetType == 'operateFunc') {
        //预览外展
        _this.previewTargetSite(item, wH)
        //右键标签展示
        _this.dataRightMenuShow(item)
        //开启直播
        // _this.initLiveRoom(item);
      }
      //加入购物车
      _this.addToCart(item)
      if (window.$chooseToCart) return
      _this.rightShow = false
    },
    //链接在客户端工作台展示
    iframeOpen(area, url, menuName) {
      if (this.IsMobile()) {
        layer.open({
          type: 2,
          title: menuName,
          area: ['100%', '100%'],
          content: url
        })
        return
      }
      var iframe = document.getElementById('MainFrame')
      if (iframe) {
        iframe.scrollIntoView({ behavior: 'smooth' })
        iframe.contentWindow.document.getElementById(area).setAttribute('src', url)
      }
    },
    //预览外展
    previewTargetSite(item, wH) {
      if (item.childmenu == 'yulanwaizhan') {
        //预览外展
        if (window.$appId != ':javascript;') {
          let newAppUrl = `http://www.520emv.com/uoqid/#/?appId=${window.$appId}`
          this.open(newAppUrl, '_blank', '预览')
        } else {
          this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该流程暂无外展平台',
            type: 'warning',
            offset: wH
          })
        }
      }
    },
    //数据展示
    dataRightMenuShow(item) {
      if (item && item.childmenu == 'tagdatashow') {
        //获取标签以及数据
        if (this.rMenuPos.top <= 140 && this.rMenuPos.top >= 110) {
          this.flowShow = true
          this.rightShow = false
        } else {
          this.blockrightShow = true
          // this.flowShow=true;
        }
      }
    },
    //开启直播
    initLiveRoom(item) {
      if (item && item.childmenu == 'openFloorLive') {
        this.open(`https://openvidu.520emv.com/#/${this.$store.state.userInfo.userId}/live/anchor?userNickName=${this.$store.state.userInfo.nickName}`, '_blank', '直播')
      }
    },
    addToCart(item) {
      if (item && (item.childmenu == 'addToCart' || item.childmenu == 'addToCart2') && this.content) {
        let productId = this.content[0].contentId
        this.joinShopCart(productId, this.contentTotal)
      }
    },
    //获取随机字符
    getRandomString() {
      return Math.random().toString(36).slice(-8)
    },
    getDetailFlowAndBlock(tabtype) {
      // const _this = this;
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getMainTopNavList.json', {
          types: tabtype,
          appId: this.$appId,
          flowId: this.$route.query.contentId
        })
        .then((res) => {
          if (res.state == 1) {
            if (tabtype == 'detail-up-block') {
              if (res.data) {
                this.nodeNavTop = res.data
                this.tempNavTop = res.data
              }
            } else if (tabtype == 'detail-left-block') {
              if (res.data) {
                this.nodeNavLeft = res.data
                this.tempNavLeft = res.data
              } else {
                this.getCircleList()
              }
            } else if (tabtype == 'detail-right-block') {
              if (res.data) {
                this.nodeNavRight = res.data
                this.tempNavRight = res.data
              }
            }
          } else {
            if (tabtype == 'detail-left-block') {
              this.getCircleList()
            }
          }
        })
    },
    getDataByBlock(item, param) {
      if (item.flowType == 'tagsData') {
        return false
      }
      const _this = this
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json', {
          appId: item.appId,
          sceneId: this.$route.query.sceneId,
          blockId: item.id,
          nodeId: item.nodeId,
          sceneGroupId: this.$route.query.sceneGroupId
        })
        .then((res) => {
          var arr = []
          if (res.data) {
            arr = this.getProduct(item.id, res.data)
          }
          // //上侧tab点击
          if (param.tabType == 'up') {
            _this.nodeNavTop = arr
            _this.tempNavTop = arr

            _this.tempNavTop.unshift(item)
          }
          if (param.tabType == 'left') {
            _this.nodeNavLeft = arr
            _this.tempNavLeft = arr

            _this.tempNavLeft.unshift(item)
          }
          //右侧tab点击
          if (param.tabType == 'right') {
            _this.nodeNavRight = arr
            _this.tempNavRight = arr

            _this.tempNavRight.unshift(item)
          }
          _this.leftTabInd = 0
          _this.picture = ''
          _this.title = ''
          _this.detail.type0 = []
          _this.detail.type1 = []
          _this.detail.type2 = []
          _this.detail.type3 = []
        })
    },
    getProduct(id, pDataArr) {
      const _this = this
      var listData = []
      if (pDataArr.length == 0) {
        return listData
      }
      _this.mp4Src = ''
      pDataArr.forEach((pData) => {
        var tags = []
        var pictures = []
        var others = []
        var btns = []
        if (!pData || !pData.standardJson) {
          return false
        } else {
          pData.standardJson.forEach((ele) => {
            if (ele.standardType == 0 && ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0)) {
              if (ele.standardData.indexOf('.mp4') > 0) {
                _this.mp4Src = _this.mp4Src ? _this.mp4Src : ele.standardData
              } else {
                pictures.push(ele.standardData)
              }
            } else if (ele.standardType == 0 && ele.standardData) {
              others.push(ele)
            } else if (ele.standardType == 3) {
              btns.push(ele)
            }
            if (ele.isShow == 1 && ele.standardType != 3) {
              tags.push(ele)
            }
          })
        }
        //标签数据构造
        listData.push({
          id: id,
          flowType: 'tagsData',
          name: others.length ? others[0].standardData : '',
          contentShowRowsSort: pData.contentShowRowsSort,
          sceneId: pData.sceneId,
          contentId: pData.contentId,
          sceneGroupId: pData.sceneGroupId,
          pictures: pictures.splice(0, 2),
          others: others.splice(0, 5),
          btns: btns.splice(0, 2),
          tags: tags.splice(0, 9)
        })
      })
      return listData
    },
    //获取今日资讯类型标签数据
    getTagsTypeTodays(list) {
      var alist = []
      list.map((ite) => {
        if (ite.fileTypeDetail == 16) {
          alist.push({
            id: ite.standardData,
            name: ite.ssoFileName,
            time: ite.ssoFileCreateTime,
            contentId: ite.contentId
          })
        }
      })
      return alist
    },
    //筛选文字信息
    getTagsTypeToday(list) {
      var alist = [],
        name,
        time
      list.map((ite, index) => {
        for (var i = 0; i < ite.length; i++) {
          if (ite[i].standardName == '名称') {
            name = ite[i].standardData
          }
          if (ite[i].standardName == '发布日期') {
            time = ite[i].standardData
          }
        }
        if (name || time)
          alist.push({
            name: name,
            time: time
          })
        if (!name && !time) {
          //删除type6中的空数据
          this.type6.splice(index, 1)
        }
      })
      return alist
    },
    isPic(url) {
      if ((url && typeof url == 'string' && url.indexOf('.png') > 0) || (url && typeof url == 'string' && url.indexOf('.jpg') > 0)) {
        return true
      }
      return false
    },
    //是否为文件
    isFile(link) {
      if (link && (link.indexOf('xlsx') > -1 || link.indexOf('pptx') > -1 || link.indexOf('docx') > -1 || link.indexOf('txt') > -1)) {
        return true
      }
      return false
    },
    //排序
    sortTags(arr) {
      const _this = this
      let cloneArr = arr.sort((a, b) => {
        let aLen = a.standardData ? (_this.isPic(a.standardData) && a.fileTypeDetail == 2 || a.standardEnName == 'product_experience' ? 0 : a.standardData.length <= 21 ? 0 : a.standardData.length) : 0
        let bLen = b.standardData ? (_this.isPic(b.standardData) && b.fileTypeDetail == 2 || b.standardEnName == 'product_experience'? 0 : b.standardData.length <= 21 ? 0 : b.standardData.length) : 0
        if(a.standardData == 'theoneandonlyAddtoCart') return 1
        if(b.standardData == 'theoneandonlyAddtoCart') return -1
        return aLen - bLen
      })
      return cloneArr
    },
    sortTagsLink(arr) {
      const _this = this
      let cloneArr = arr.sort((a, b) => {
        // let aLen = (_this.isPic(a.link) || _this.isVideo(a.link)) ? 0 : (a.link.length <= 36 ? 0 : a.link.length);
        // let bLen = (_this.isPic(b.link) || _this.isVideo(b.link)) ? 0 : (b.link.length <= 36 ? 0 : b.link.length);
        let aLen = _this.isPic(a.link) || _this.isVideo(a.link) ? 0 : a.link.length <= 21 ? 0 : 1
        let bLen = _this.isPic(b.link) || _this.isVideo(b.link) ? 0 : b.link.length <= 21 ? 0 : 1
        return aLen - bLen
      })
      return cloneArr
    },
    btnColor() {
      return 'blue'
    },
    goToPath(item) {
      if (item.flowType == 'block') {
        // var originName = JSON.parse(sessionStorage.getItem('originName'));
        // if (originName) {
        //   let url = `https://${window.location.hostname}${window.location.pathname}?blockId=${originName.blockId}&contentId=${originName.contentId}&appId=${this.getQuery('appId')}`
        // this.$router.replace({name:"flowDetail",query:originName});
        // window.location.reload();
        //   window.location.replace(url);
        //   return false;
        // } else {
        window.location.reload()
        // }
      }
      if (item.flowType == 'flow') {
        // this.$router.go(-1);
        // var path = window.location.pathname.substring(0, window.location.pathname.length - 10)
        this.$router.replace({ path: `/`, query: { appId: this.$appId } })
      }
      if (item.flowType == 'tagsData') {
        //this.$router.replace({name:"flowDetail",query:{blockId:item.id,contentId:item.contentId}});
        let url = `https://${window.location.hostname}${window.location.pathname}?blockId=${item.id}&contentId=${item.contentId}&appId=${this.$appId}`
        window.location.replace(url)
      }
    },
    handleDetail(item) {
      var { sceneId, sceneGroupId, contentId } = this.$route.query
      this.$router.push({ name: 'flowDetail', query: { blockId: item.id, contentId: contentId } })
    },
    getFileType(fileName) {
      return fileName.split('.') ? fileName.split('.') : ''
    },
    getListTitle() {
      var list = [...this.detail.type0, ...this.detail.type1, ...this.detail.type2]
      this.newsData = this.getTagsTypeTodays(list)
      this.mp4Src = ''
      if (list && list.length) {
        list.forEach((ele) => {
          if (typeof ele.standardData == 'string') {
            if (ele.standardData && ele.standardData.indexOf('.mp4') > 0) {
              this.mp4Src = this.mp4Src ? this.mp4Src : ele.standardData
            } else if ((ele.standardData && ele.standardData.indexOf('.png') > 0) || ele.standardData.indexOf('.jpg') > 0) {
              this.picture = ele.standardData
            } else if (ele.standardData && ele.fileTypeDetail == 15) {
              // this.excells.push(ele.standardData);
              let transForId = `https://${window.location.host}/cme-sso-app/space/transform?id=` + ele.standardData.split('/')[ele.standardData.split('/').length - 1].split('.')[0]
              let fname = ele.ssoFileName ? ele.ssoFileName : ele.standardData.split('/')[ele.standardData.split('/').length - 1]
              var t = this.getFileType(fname)
              this.excellsList.push({ name: fname, link: ele.standardData, t: t, tranId: transForId })
            } else if (ele.standardData && ele.fileTypeDetail == 4) {
              // this.article.push(ele.standardData);
              let transForId = `https://${window.location.host}/cme-sso-app/space/transform?id=` + ele.standardData.split('/')[ele.standardData.split('/').length - 1].split('.')[0]
              let fname = ele.ssoFileName ? ele.ssoFileName : ele.standardData.split('/')[ele.standardData.split('/').length - 1]
              var t = this.getFileType(fname)
              this.articleList.push({ name: fname, link: ele.standardData, t: t, tranId: transForId })
            } else {
              if (ele.standardData && !this.title) {
                this.pathArr[2] = {
                  id: this.$route.query.blockId,
                  flowType: 'tagsData',
                  contentId: this.$route.query.contentId,
                  name: ele.standardData
                }
                this.title = ele.standardData
              }
            }
          }
        })
      }
    },
    getShowTag(list) {
      var arr = []
      list.forEach((ite) => {
        if (ite.isPriority == 1) {
          arr.push(ite)
        }
      })
      if (arr.length > 6) {
        arr = arr.slice(0, 6)
      }
      return arr
    },
    handleTabSwitch(ind) {
      this.tabInd = ind
    },
    //获取相关推荐块
    getBlockTags(one) {
      const _this = this
      _this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getStandardDataForPlatform.json', {
          appId: _this.getQuery('appId'),
          contentId: _this.$contentId,
          blockId: _this.getQuery('blockId'),
          isMedia: _this.getQuery('isMedia') ? _this.getQuery('isMedia') : _this.floorType == 'media-scene' ? '1' : this.parameter,
          floorEnName: _this.getQuery('floorflowId')
        })
        .then((res) => {
          _this.$store.commit('showOther', true)
          if (res.state == 1 && JSON.stringify(res.data.standardJson) != '{}') {
            this.oldStandardShow = true
            this.detail = res.data.standardJson
            var _url = res.data.dynamicDataInter
            this.sortTag = this.sortTags([...this.detail.type0, ...this.detail.type1, ...this.detail.type2])
            if (_url) {
              var url = _url.substring(20)
              this.$http.get(url, { appId: '' }).then((res1) => {
                var keys = Object.keys(res1.data)
                for (var j = 0; j < keys.length; j++) {
                  this.detail.type0.forEach((item) => {
                    if (item.standardEnName && keys[j] === item.standardEnName && res1.data[item.standardEnName]) {
                      item.standardData = res1.data[item.standardEnName]
                    }
                  })
                  this.detail.type1.forEach((item) => {
                    if (item.standardEnName && keys[j] === item.standardEnName && res1.data[item.standardEnName]) {
                      item.standardData = res1.data[item.standardEnName]
                    }
                  })
                  this.detail.type2.forEach((item) => {
                    if (item.standardEnName && keys[j] === item.standardEnName && res1.data[item.standardEnName]) {
                      item.standardData = res1.data[item.standardEnName]
                    }
                  })
                  this.detail.type3.forEach((item) => {
                    if (item.standardEnName && keys[j] === item.standardEnName && res1.data[item.standardEnName]) {
                      item.standardData = res1.data[item.standardEnName]
                    }
                  })
                }
                this.getListTitle()
              })
            } else {
              this.detail = res.data.standardJson
              this.getListTitle()
            }
          } else if (res.state == 1 && JSON.stringify(res.data.standardJsonNew) != '{}') {
            this.tenBlock = true
            var standard = res.data.standardJsonNew
            //抖变视界
            if (standard.type5 && standard.type5.length && this.newLoftShow == 2) {
              _this.baijiaData = standard.type5

              var pictures = [],
                others = [],
                have = false,
                pcVideo = '',
                mobileVideo = ''
              standard.type5.forEach((ele) => {
                //判断是否有视频
                var videoL = ele.filter((tag) => tag.standardEnName == 'videoShow' && tag.standardData && !_this.isPic(tag.standardData)).length
                ele.forEach((item) => {
                  if (item.contentId && item.contentId == this.$contentId) {
                    have = true
                    if (item.standardEnName == 'VideoCover' && item.standardData && !this.childContentId) {
                      window.$imageL = item.standardData
                    }
                    //有视频图片不显示
                    if ((_this.isPic(item.standardData) && !videoL) || _this.isVideo(item.standardData)) {
                      if (item.standardEnName == 'videoShow' || item.standardEnName == 'VideoCover') {
                        pcVideo = item
                      }
                      if (item.standardEnName == 'subVideo1') {
                        mobileVideo = item
                      }
                      if (this.IsMobile()) {
                        if (mobileVideo) {
                          pictures.push(mobileVideo)
                        } else {
                          pictures.push(pcVideo)
                        }
                      } else {
                        pictures.push(pcVideo)
                      }
                    } else if (!_this.isPic(item.standardData)) {
                      others.push(item)
                    }
                  }
                })
              })

              if (!have) {
                standard.type5[0].forEach((item) => {
                  if (_this.isPic(item.standardData) || _this.isVideo(item.standardData)) {
                    pictures.push(item)
                  } else {
                    others.push(item)
                  }
                })
              }
              
              
              this.pics = pictures
              this.sortTagBJ = this.sortTags(others)
              window.$contentData = this.sortTagBJ
            }
            //中机知道
            if (standard.type2 && standard.type2.length && this.newLoftShow == 1) {
              _this.zhongjiData = standard.type2
              standard.type2[0].forEach(function (item, ind) {
                if (item.standardName == '安装包' || item.standardName == '下载地址') {
                  standard.type2[0].splice(ind, 1)
                }
              })
              standard.type2[0].forEach(function (item, ind) {
                if (item.standardName == '安装包' || item.standardName == '下载地址') {
                  standard.type2[0].splice(ind, 1)
                }
              })
              var pictures = [],
                others = [],
                have = false
              standard.type2.forEach((ele) => {
                ele.forEach((item) => {
                  if (item.contentId && item.contentId == this.$contentId) {
                    have = true
                    if (_this.isPic(item.standardData) && item.fileTypeDetail == 2) {
                      pictures.push(item)
                    } else {
                      others.push(item)
                    }
                  }
                })
              })
              if (!have) {
                standard.type2[0].forEach((item) => {
                  if (_this.isPic(item.standardData)) {
                    pictures.push(item)
                  } else {
                    others.push(item)
                  }
                })
              }
              this.zhongjiPic = pictures
              others.splice(1, 0, { standardData: 'theoneandonlyAddtoCart' })
              this.sortTag = this.sortTags(others)
              this.integrationSwiperData = [{contentName:this.sortTag[0].standardData}]
              window.$contentData = this.sortTag
            }
            //ZJ直播
            if (standard.type3 && standard.type3.length && this.newLoftShow == 6) {
              _this.tongping = this.sortTags(standard.type3[0])
            }

            //今日资讯
            if (standard.type6 && standard.type6.length && this.newLoftShow == 7) {
              var index = _this.matching(standard.type6)
              _this.type6 = JSON.parse(JSON.stringify(standard.type6))
              _this.contents = [JSON.parse(JSON.stringify(standard.type6))[index]]
              window.$contentData = _this.contents[0]
              if (!_this.newsData.length) {
                _this.newsDatas = standard.type6[0]
              }
              _this.filtrate(standard.type6[index], (_this.newsDatas = []))
            }

            //百家文库
            if (standard.type7 && standard.type7.length && this.newLoftShow == 8) {
              var index = _this.matching(standard.type7)
              _this.baijiawenkuData = [JSON.parse(JSON.stringify(standard.type7))[index]]
              window.$contentData = _this.baijiawenkuData[0]

              _this.filtrate(standard.type7[index], (_this.articleList = []))
              for (var i = 0; i < standard.type7[0].length; i++) {
                var link = standard.type7[0][i].standardData
                if (link.indexOf('xlsx') > -1 || link.indexOf('pptx') > -1 || link.indexOf('docx') > -1 || link.indexOf('txt') > -1) {
                  _this.caozuoFunc(link, 'file', 0)
                  break
                }
              }
            }
            //AI设备
            if (standard.type9 && standard.type9.length && this.newLoftShow == 10) {
              var index = _this.matching(standard.type9)
              _this.AIshebeiData = [JSON.parse(JSON.stringify(standard.type9))[index]]
              window.$contentData = _this.AIshebeiData[0]

              _this.filtrate(standard.type9[index], (_this.AIsortTag = []))
            }
          }
          // 自定义页面
          if (res.state == 1 && JSON.stringify(res.data.resultStandard) != '{}') {
            var standard = res.data.resultStandard
            if (standard.types2 && standard.types2.length) {
              this.types1 = standard.types2
            }
            if (standard.types5 && standard.types5.length) {
              this.types2 = standard.types5
            }
            if (standard.types4 && standard.types4.length) {
              this.types3 = standard.types4
            }
            if (standard.types0 && standard.types0.length) {
              this.types4 = standard.types0
            }
            if (standard.types1 && standard.types1.length) {
              this.types5 = standard.types1
            }
            if (standard.types3 && standard.types3.length) {
              this.types6 = standard.types3
            }
            if (standard.types6 && standard.types6.length) {
              this.types7 = standard.types6
            }
            if (standard.types7 && standard.types7.length) {
              this.types8 = standard.types7
            }
            if (standard.types8 && standard.types8.length) {
              this.types9 = standard.types8
            }
            if (standard.types9 && standard.types9.length) {
              this.types10 = standard.types9
            }
          }
        })
        // .then((res) => {
        //   _this.$http
        //     .get('/zciid-deliverable/api/webapp/app/relation/flowPath.json', {
        //       wzAppId: _this.getQuery('appId'),
        //       contentId: _this.$contentId,
        //       floorEnName: _this.getQuery('floorflowId')
        //       // appId: [..._this.zhongjiPic,..._this.sortTag].filter((tags)=>tags.standardEnName=='productMarking')[0].standardData,
        //       // wzAppId: _this.getQuery('appId'),
        //       // appName:  _this.sortTag[0].standardData
        //     })
        //     .then((req) => {
        //       if (req.state == 1 && req.data.length) {
        //         req.data.forEach((ele, ind) => {
        //           ele.show = true
        //         })
        //         _this.blueContent = req.data
        //       }
        //     })
        // })
        .then(() => {
          //初始化轮播图
          _this.swiperFn()
          if(!_this.IsMobile()){
            $('#app').viewer({'initWidth':window.innerWidth})
          }else{
            initViewerApp()
          }
          window.$grabYes = true
        })
      _this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/get/getDetailNewSign.json', {
          appId: _this.$appId,
          blockId: _this.getQuery('blockId')
        })
        .then((res) => {
          if (res.state == 1) {
            _this.newStandardShow = res.data
          }
        })
      //有childContentId直接默认
      if(this.childContentId){
        this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getWzSerializeBycontentId.json", {
          contentId:this.childContentId
        }).then(res => {
          if(res.state == 1 ){
            this.integrationData = res.data.standardJson

            if(res.data.sign == 2){
              //抖变世界类型做特殊处理
              var pictures = [],
                  others = [],
                  pcVideo = '',
                  mobileVideo = '',
                  ele = res.data.standardJson
                  //判断是否有视频
                  var videoL = ele.filter((tag) => tag.standardEnName == 'videoShow' && tag.standardData && !this.isPic(tag.standardData)).length
                  
                  ele.forEach((item) => {
                    if (item.standardEnName == 'VideoCover' && item.standardData) {
                      //视频封面
                      window.$imageL = item.standardData
                    }
                    //有视频图片不显示
                    if ((this.isPic(item.standardData) && !videoL) || this.isVideo(item.standardData)) {
                      if (item.standardEnName == 'videoShow' || item.standardEnName == 'VideoCover') {
                        pcVideo = item
                      }
                      if (item.standardEnName == 'subVideo1') {
                        mobileVideo = item
                      }
                      if (this.IsMobile()) {
                        if (mobileVideo) {
                          pictures.push(mobileVideo)
                        } else {
                          pictures.push(pcVideo)
                        }
                      } else {
                        pictures.push(pcVideo)
                      }
                    } else if (!this.isPic(item.standardData)) {
                      others.push(item)
                    }
                  })
                  this.integrationData = [...pictures,...others]
            }
          }
        })
      }
      
    },
    //筛选数据
    filtrate(arr, ret) {
      arr.forEach((ele) => {
        if (ele.fileTypeDetail == 4 || ele.fileTypeDetail == 15) {
          let transForId = `https://${window.location.host}/cme-sso-app/space/transform?id=` + ele.standardData.split('/')[ele.standardData.split('/').length - 1].split('.')[0]
          let fname = ele.ssoFileName ? ele.ssoFileName : ele.standardData.split('/')[ele.standardData.split('/').length - 1]
          var t = this.getFileType(fname)
          ret.push({ name: ele.standardName, ssoFileName: fname, link: ele.standardData, t: t, tranId: transForId, standardEnName: ele.standardEnName })
        } else {
          ret.push({ name: ele.standardName, link: ele.standardData, standardEnName: ele.standardEnName })
        }
      })
      ret = this.sortTagsLink(ret)
      return ret
    },
    //标签取值方法
    getStandardData(nameArr, type, nameData, allTagsJson) {
      const allTagsStandArr = allTagsJson
      const sNames = typeof nameArr == 'string' ? [nameArr] : nameArr
      var filterStandArr = allTagsStandArr.filter((ite) => sNames.indexOf(ite.standardName) > -1)
      // var filterData = sNames.indexOf(allTagsStandArr.standardName) > -1 ? allTagsStandArr.standardData : nameData;
      var filterData = filterStandArr[0] ? filterStandArr[0].standardData : nameData
      var message = ''
      var requiredMsg = ''
      switch (type) {
        case 'required':
          if (!filterData) {
            requiredMsg = `${sNames[0]}`
          }
          break
        case 'number':
          if (isNaN(filterData)) {
            message = `${sNames[0]}`
          }
          break
      }
      if (requiredMsg) {
        this.requiredMsgs.push(requiredMsg)
      }
      if (message) {
        this.messages.push(message)
      }
      return filterData
    },
    //加入购物车 所需参数拼接
    joinShopCart(pId, allTagsJson, item) {
      var asset = this.getQuery('assetId')
      this.messages = []
      this.requiredMsgs = []
      //产品名称
      var chanpinmingchen = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName').length
        ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName')[0].standardData
        : this.getStandardData(['名称', '组织名称', '企业名称', '个人名称', '产品名称', '图片名称'], 'required', '', allTagsJson)
      //产品图片
      var chanpintupian = allTagsJson.filter((tags) => tags.fileTypeDetail == 2 && tags.standardData).length ? allTagsJson.filter((tags) => tags.fileTypeDetail == 2 && tags.standardData)[0].standardData : ''
      //单价
      var price = allTagsJson.filter((tags) => tags.standardData && (tags.standardEnName == 'cpyxprice' || tags.standardEnName == 'xmjcprice' || tags.standardEnName == 'basicPrice'))
      var danjia = price.length ? (price ? price[0].standardData : '') : this.getStandardData(['', '基础价格', '产品基础标签', '产品价格', '价格', '基准价', '金额'], 'number', '', allTagsJson)
      //数量
      var shuliang = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number')[0].standardData : this.getStandardData('数量', 'number', '1', allTagsJson)
      //用户ID
      var userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : ''
      //产品标识
      var productId = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking')[0].standardData : ''
      //资产交易价
      var assetsPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice')[0].standardData : ''
      //资产单位
      var assetsUnit = asset ? assetsPrice.replace(parseFloat(assetsPrice) + '/', '') : allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit')[0].standardData : ''
      //租赁交易价
      var periodicPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice')[0].standardData : ''
      //租赁单位
      var periodicUnit = asset ? periodicPrice.replace(parseFloat(periodicPrice) + '/', '') : allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit')[0].standardData : ''
      //次数租赁价
      var timesPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'timesPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'timesPrice')[0].standardData : ''
      //次数租赁单位
      var timesUnit = timesPrice.replace(parseFloat(timesPrice) + '/', '')
      if ((this.requiredMsgs.length > 0 || !chanpintupian || !danjia) && !assetsPrice && !periodicPrice) {
        this.$notify({
          title: '提示',
          message: `(产品名称或图片名称、产品图片、单价)为必填选项，请去补充标签，并生成，再进行此操作`,
          type: 'warning',
          duration: 5000
        })
        return
      }

      if (this.messages.length > 0) {
        this.$notify({
          title: '提示',
          message: `${this.messages.join('、')}，的值不是数字类型，请输入阿拉伯数字`,
          type: 'warning',
          duration: 5000
        })
        return
      }

      if (danjia == '面议') {
        this.$notify({
          title: '提示',
          message: '此产品不支持加入购物车',
          type: 'warning',
          duration: 5000
        })
        return
      }
      if (!productId && !asset) {
        this.$notify({
          title: '提示',
          message: '该产品暂不能购买',
          type: 'warning'
        })
        return
      }
      var prevMerchantId = this.getQuery('prevMerchantId'),
        prevMerchantName = this.getQuery('prevMerchantName'),
        prevTypes = decodeURIComponent(this.getQuery('prevTypes')),
        prevPfId = this.getQuery('prevPfId'),
        cart = {
          productName: chanpinmingchen,
          productImg: chanpintupian,
          prices:
            this.$store.state.memberLevel && this.contentTotal[0][this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && this.contentTotal[0].memberEndTime
              ? this.contentTotal[0][this.getMemberLevel(this.$store.state.memberLevel).memberLevel]
              : assetsPrice
                ? assetsPrice
                : periodicPrice
                  ? periodicPrice
                  : this.contentTotal[0].discountTypes
                    ? this.contentTotal[0].priceType
                    : danjia,
          activityType: this.$store.state.memberLevel && this.contentTotal[0][this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && this.contentTotal[0].memberEndTime ? 'blankVip' : this.contentTotal[0].discountTypes ? this.contentTotal[0].discountTypes : '',
          buyNumber: shuliang,
          userId: userId ? userId : '',
          codes: userId ? '' : this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud'),
          productId: asset ? 'asset-' + asset : productId ? productId + '-' + pId : pId ? pfId : this.getQuery('pfId'),
          wzAppId: this.getQuery('appId') ? this.getQuery('appId') : '',
          units: assetsPrice ? assetsUnit : periodicPrice ? periodicUnit : '个',
          dataType: assetsPrice ? 1 : periodicPrice ? 2 : 0,
          merchantId: prevMerchantId ? prevMerchantId : item[0].appId ? item[0].appId : '',
          merchantName: prevMerchantName ? prevMerchantName : item[0].appName ? item[0].appName : '',
          
          detailsUrl: location.href,
          // detailsUrl:'',
          pfId:prevPfId ? prevPfId : window.$pfId ? window.$pfId : '' ,
          payPfId: window.$pfId ? window.$pfId : '',
          types: (prevPfId ? prevPfId : window.$pfId ? window.$pfId : '') == (window.$pfId ? window.$pfId : '') ? 1 : 2
        }

      if (assetsPrice && periodicPrice) {
        window.$chooseToCart = true
        this.chooseToCart(parseFloat(assetsPrice), assetsUnit, parseFloat(periodicPrice), periodicUnit, JSON.stringify(cart).replace(/"/g, '&quot;'), '', '', parseFloat(timesPrice), timesUnit)
        return
      } else {
        window.$chooseToCart = false
      }
      this.$http.post('/oqmid-pay-tool-web/shop/cart/save', { arrs: JSON.stringify(cart) }, 'a').then((res) => {
        if (res.state == 1) {
          const h = this.$createElement
          this.$notify({
            title: '提示',
            dangerouslyUseHTMLString: true,
            type: 'success',
            duration: 3000,
            message: h('div', { class: 'personnel' }, [
              h('p', { class: 'isCreate' }, '加入购物车成功！'),
              h(
                'button',
                {
                  class: 'personnel-btn',
                  on: {
                    click: this.toOpen
                  }
                },
                '购物车'
              )
            ])
          })
        } else {
          this.$notify({
            title: '提示',
            message: `该产品暂不支持购买`,
            type: 'warning',
            duration: 5000
          })
        }
      })
    },
    // optionClick (btn) {
    //   if (btn.standardName == '加入购物车') {
    //     var cart = this.joinShopCart();
    //     this.$http
    //       .post(btn.rightButtonUrl, { arrs: JSON.stringify(cart) })
    //       .then(res => {
    //         if (res.state == 1) {
    //           this.$notify({
    //             title: '提示',
    //             message: '加入购物车成功，请点击顶部导航购物车列表进行购买！',
    //             type: 'success'
    //           })
    //         }
    //       });
    //   } else {
    //     this.$notify({
    //       title: '提示',
    //       message: '右键工具标签未选择对应右键接口，请先去补充！',
    //       type: 'warning'
    //     })
    //   }
    // },
    toOpen() {
      this.$notify.closeAll()
      this.handleShopCart()
    },
    //获取勾选详情楼层展示类型
    getCheckFrame() {
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getDetailFloor.json', {
          flowId: this.getQuery('blockId'),
          flowOrDetail: 'block'
        })
        .then((res) => {
          if (res.state == 1) {
            this.iframeShow = res.data
            this.$nextTick(() => {
              if (res.data.indexOf('1') > -1 && top != self) {
                setTimeout(() => {
                  topWin.JFrame.getId('MainFrame1').contentWindow.document.getElementById('toolsFrame').contentWindow.location.href = 'https://www.520emv.com/uoqid/#/liveMain'
                }, 1000)
              }
            })
          }
        })
    },
    //获取详情勾选商圈数据
    getCircleList() {
      var flowId = ''
      var flowOrDetail = ''

      if (this.$route.query.contentId) {
        flowId = this.$route.query.contentId
        flowOrDetail = 'detail'
      } else {
        if (this.$route.query.blockId) {
          flowId = this.$route.query.blockId
          flowOrDetail = 'block'
        } else {
          return false
        }
      }
      this.$http
        .get('/zciid-deliverable/showPlatformStyle/flow/api/getCircleListByFlowId.json', {
          flowId: flowId,
          flowOrDetail: flowOrDetail
        })
        .then((res) => {
          if (res.state == 1 && res.data) {
            this.leftAndRightNavHeight = res.data
            this.nodeNavLeft = res.data
          }
        })
    },
    initEchart() {
      // const _self = this;
      var charArr = [
        {
          sceneGroupId: '',
          contentId: 'zciid-jfwgl001000000000000guru1599891131419105350',
          sceneId: 'iaiid-a018iaiid0011599886259762221459',
          standardJson: [
            {
              sceneGroupId: '',
              standardName: '图释',
              standardData: 'A',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885370619926427',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            },
            {
              sceneGroupId: '',
              standardName: '周一',
              standardData: '20',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885370619926427',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            },
            {
              sceneGroupId: '',
              standardName: '周二',
              standardData: '30',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885389090912067',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            },
            {
              sceneGroupId: '',
              standardName: '周三',
              standardData: '40',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885389090912067',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            },
            {
              sceneGroupId: '',
              standardName: '周四',
              standardData: '50',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885389090912067',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            },
            {
              sceneGroupId: '',
              standardName: '单位',
              standardData: '℃',
              sceneId: 'iaiid-a018iaiid0011599886259762221459',
              standardId: 'zciid-jfwgl001000000000000guru1599885389090912067',
              standardType: '0',
              isPriority: '0',
              isShow: '0',
              flowType: 'standard'
            }
          ]
        }
      ]

      //1.2 有数据 进行处理
      //1.2.1 取出 x轴 list xAxios  y轴 list series
      var xAxios = [],
        series = [],
        legend = [],
        yName
      charArr.forEach((chart, cind) => {
        var item = {
          name: '',
          smooth: true,
          type: 'line',
          data: []
        }
        var standLen = chart.standardJson.length
        if (standLen > 0) {
          var lineData = []
          chart.standardJson.forEach((stand) => {
            if (stand.standardName == '图释') {
              legend.push(stand.standardData)
              item.name = stand.standardData
            } else if (stand.standardName == '单位') {
              yName = stand.standardData
            } else {
              if (cind == 0) {
                xAxios.push(stand.standardName)
                // alert(stand.standardName)
              }
              lineData.push(stand.standardData ? stand.standardData : Math.round(Math.random() * 100))
            }
          })
          item.data = lineData
          series.push(item)
        }
      })
      var option = {
        color: ['#d14a61', '#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        toolbox: {
          feature: {
            magicType: {
              type: ['line', 'bar']
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          data: legend
        },
        xAxis: [
          {
            type: 'category',
            data: xAxios,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            name: yName,
            type: 'value'
          }
        ],
        series: series
      }
      // var _this = this;
      // var myChart = window.echarts.init(this.$refs.echart);
      // myChart.setOption(option);
    }
  }
}
</script>
<style scoped>
.shoppingCart span {
  display: inline-block;
  height: 36px;
  line-height: 34px;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}
.shoppingCart-l {
  width: 90px;
  color: #0c78cf;
  border: 1px solid #0d78cf;
  box-sizing: border-box;
  padding-left: 36px;
  background: url('../assets/images/icons/shopping_cart.png') no-repeat 10px 9px;
}
.shoppingCart-l:hover {
  color: #006bc2;
  background: #f2faff url('../assets/images/icons/move_shopping_cart.png') no-repeat 10px 9px;
}
.shoppingCart-r {
  width: 116px;
  color: #fff;
  border: 1px solid #0d78cf;
  box-sizing: border-box;
  padding-left: 36px;
  position: relative;
  background: #0c78cf url('../assets/images/icons/add_shopping_cart.png') no-repeat 10px 9px;
}
.shoppingCart-r:hover {
  background-color: #006bc2;
}
.textTit {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.textTit span {
  margin-right: 10px;
}
#create {
  width: 1200px;
  height: 400px;
  margin-bottom: 24px;
}
#bottom {
  width: 1200px;
  height: 50px;
  border: 1px dashed #2f8eed;
  color: #2f8eed;
  position: relative;
  margin-bottom: 24px;
}
#bottom .first {
  position: absolute;
  top: 16px;
  left: 580px;
}
#bottom .secont {
  position: absolute;
  top: 15px;
  left: 580px;
  display: none;
}
#bottom:hover .secont {
  display: block;
}
#bottom:hover {
  width: 1200px;
  height: 50px;
  background-color: #2f8eed;
}
.attribute-r.curr {
  color: #0c78cf !important;
  cursor: pointer;
}
.attribute-r.curr:hover {
  text-decoration: underLine;
}
.wz-open-pack-up {
  width: 1200px;
  height: 24px;
  background: #fafafa;
  text-align: center;
  border-top: 1px solid #dddddd;
}
.wz-open-pack-up .wz-open-pack-up-img.pack_up {
  background: url(~@/assets/image/images/wz_pack_up.png) no-repeat center;
  width: 30px;
  height: 25px;
  display: inline-block;
  line-height: 25px;
  cursor: pointer;
}
.wz-open-pack-up .wz-open-pack-up-img.open {
  background: url(~@/assets/image/images/wz_open.png) no-repeat center;
  width: 30px;
  height: 25px;
  display: inline-block;
  line-height: 25px;
  cursor: pointer;
}
/* #bcd-productDetail-box{
  overflow: auto;
} */
#bcd-productDetail-box img {
  object-fit: contain !important;
}
#bcd-productDetail-box.showMore .commodity-detail {
  border: none;
}
#bcd-productDetail-box.showMore .titles {
  display: none;
}
@media screen and (min-width: 768px) {
  #bcd-productDetail-box.showMore .d-content,
  #bcd-productDetail-box.hideTop .d-content {
    padding: 20px 0 0 !important;
  }
}
</style>
<style lang="scss">
.shoppingCart-r .shopping.el-cascader-menu {
  position: absolute;
  top: 45px;
  left: 0;
  // right: 50%;
  // transform: translateX(-50%);
  background: #fff;
  width: 300px;
  height: 200px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  .el-cascader-menu__wrap.el-scrollbar__wrap {
    overflow-y: hidden;
  }
  .el-cascader-menu__wrap {
    height: 200px !important;
  }
  .triangle {
    position: absolute;
    top: -4px;
    left: 20%;
    margin-left: -2px;
    width: 0;
    height: 0;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    border-bottom: 4px solid #fff;
  }
}
.bcd-productDetail-box .commodity-detail .specs > li{
  .productBrief{
    width: 100%;
    display: inline !important;
    .lineHeight{
          img,video{
            width: 100%;
          }
          video{
            max-height: 360px;
          }
          p {
            line-height: 28px;
          }
      } 
  }
} 
</style>
<style scoped>
.box-type {
  display: flex;
}
.swiperLeft {
  flex-direction: row-reverse;
}
.swiperRight1 {
  width: 450px;
  display: flex;
}
.swiperRight7 {
  width: 100%;
  display: flex;
}
.swiperDown1 {
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.swiperDown7 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.swiperRight2 {
  width: 350px;
  height: 350px;
}
.swiperRight8 {
  width: 100%;
  height: 350px;
}
.swiperDown2 {
  width: 100%;
  height: 268px;
}
.swiperRight3 {
  width: 15px;
  height: 100%;
}
.swiperDown3 {
  width: 100%;
  height: 30px;
}
.swiperRight4 {
  display: flex;
  align-items: center;
  height: 350px;
  width: 54px;
}
.swiperRight9 {
  display: flex;
  align-items: center;
  height: 350px;
  width: 158px;
}
.swiperDown4 {
  display: flex;
  align-items: center;
  width: 100%;
}
.swiperRight5 {
  height: 100%;
}
.swiperDown5 {
  width: 100%;
}
.swiperRight6 {
  height: 100%;
  width: 158px;
}
.swiperRight6 li {
  width: 154px !important;
}
.swiperDown6 {
  width: 100%;
  height: 69px;
}
.swiperDown6 li {
  height: 65px;
}
.detail-contents.swiper-container.swiperRight5 li {
  width: 50px !important;
  /* background-color: #ededed; */
}
.detail-contents.swiper-container.swiperDown5 li {
  height: 50px;
  /* background-color: #ededed; */
}
/* .thumbs.swiper-container li {
  background-color: #ededed;
} */
.detail-contents.swiper-container .swiper-slide-thumb-active {
  border: 2px solid red;
}
.detail-contents .swiper-wrapper {
  height: 100%;
  position: relative;
}
.swiperDown {
  position: relative;
}
.swiperDown .arrow-left.swiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 0;
  left: 30%;
  margin-top: -13px;
  transform: rotate(90deg);
  background: url('~@/assets/images/product_detail/recommend_arrow_left.png') no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-right.swiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  bottom: 0;
  left: 30%;
  margin-bottom: -13px;
  transform: rotate(90deg);
  right: 0;
  background: url('~@/assets/images/product_detail/recommend_arrow_right.png') no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-left.swiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url('~@/assets/images/product_detail/recommend_arrow_left.png') no-repeat center;
  cursor: pointer;
}
.swiperDown .arrow-right.swiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url('~@/assets/images/product_detail/recommend_arrow_right.png') no-repeat center;
  cursor: pointer;
}

.blue-btn {
  float: right;
  margin-top: 6px;
  margin-right: 10px;
  font-size: 14px;
  line-height: 24px;
  padding: 0 10px;
  text-align: center;
  background: #2f8eed;
  color: #fff;
}
.right-content {
  width: 100%;
}
.z-chart {
  height: 328px;
  width: 1200px;
}
/*产品详情总样式  开始*/
/*左侧图片轮播 开始*/
/* .bcd-productDetail-box .commodity-show{height:326px;} */
.bcd-productDetail-box .commodity-show .commodity-pic {
  float: left;
}
.bcd-productDetail-box .commodity-show .commodity-pic .pic {
  width: 324px;
  height: 324px;
  border: 1px solid #ddd;
  vertical-align: middle;
  background: #fff;
}
#commodity-pic {
  width: 100%;
  height: 100%;
}
.bcd-productDetail-box .commodity-show .commodity-pic .pic span {
  display: block;
  float: left;
  vertical-align: middle;
  width: 348px;
  height: 348px;
}
.bcd-productDetail-box .commodity-show .commodity-pic .pic span video {
  width: 100%;
  height: 100%;
}
.bcd-productDetail-box .commodity-show .commodity-pic .pic img {
  display: block;
  border: 0 none;
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
/*左侧图片轮播 结束*/

/*产品右侧 开始*/
.bcd-productDetail-box .commodity-information {
  margin-left: 20px;
  width: calc(100% - 370px);
  width: -moz-calc(100% - 370px);
  width: -webkit-calc(100% - 370px);
  width: -o-calc(100% - 370px);
  width: -ms-calc(100% - 370px);
}

.bcd-productDetail-box .commodity-show .commodity-infos {
  background: #fff;
}
.bcd-productDetail-box .commodity-show .commodity-infos .tit {
  max-height: 55px;
  overflow: hidden;
  color: #333;
  font-size: 22px;
  line-height: 28px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos {
  font-size: 14px;
  color: #666;
  line-height: 28px;
  margin-top: 14px;
  min-height: 216px;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .in {
  width: calc((100% - 40px) / 3);
  width: -moz-calc((100% - 40px) / 3);
  width: -webkit-calc((100% - 40px) / 3);
  width: -o-calc((100% - 40px) / 3);
  width: -ms-calc((100% - 40px) / 3);
  margin-right: 20px;
  min-height: 200px;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .in:last-child {
  margin-right: 0;
}

.bcd-productDetail-box .commodity-show .commodity-infos .infos .width30 {
  overflow: hidden;
  height: 36px;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 36px;
  font-size: 14px;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .attribute-l {
  color: #999;
  text-align: justify;
  width: 56px;
  overflow: hidden;
  white-space: nowrap;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .attribute-r {
  color: #333;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .red {
  color: #f14c4a;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .red .price {
  font-size: 24px;
  font-weight: bolder;
}
.bcd-productDetail-box .commodity-show .commodity-infos .infos .discount {
  display: inline-block;
  height: 16px;
  line-height: 16px;
  background: #f14c4a;
  color: #fff;
  font-size: 12px;
  margin-left: 8px;
  padding: 0 6px;
}

.bcd-productDetail-box .commodity-show .commodity-infos .btn-group {
  margin-top: 14px;
  height: 36px;
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group li {
  float: left;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group li a {
  font-size: 14px;
  min-width: 84px;
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  height: 36px;
  line-height: 36px;
  padding: 0 12px;
  background: #2f8eed;
  color: #fff;
  border-radius: 2px;
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group a.blue {
  background: #2f8eed;
  color: #ffffff;
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group a.green {
  background: #12bca6;
  color: #ffffff;
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group a:hover {
  filter: brightness(1.1);
}
.bcd-productDetail-box .commodity-show .commodity-infos .btn-group li img {
  display: inline-block;
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 5px;
}
/*产品右侧 结束*/

/*下方产品介绍  开始*/
.bcd-productDetail-box .commodity-detail .specs {
  font-size: 12px;
  color: #666;
  line-height: 28px;
}
.bcd-productDetail-box .commodity-detail .specs .time{
  margin-left: 14px;
}
.bcd-productDetail-box .commodity-detail .specs .blueColor{
  color: #2f8eed;
  cursor: pointer;
}
.bcd-productDetail-box .commodity-detail .specs > li {
  height: 36px;
  line-height: 36px;
  width: 574px;
  margin-right: 20px;
  width: calc((100% - 20px) / 2);
  width: -moz-calc((100% - 20px) / 2);
  width: -webkit-calc((100% - 20px) / 2);
  width: -o-calc((100% - 20px) / 2);
  width: -ms-calc((100% - 20px) / 2);
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.bcd-productDetail-box .commodity-detail .specs > li.allWidth{
  width: 100%;
  margin-right: 0;
}
.bcd-productDetail-box .commodity-detail .specs > li:not(.shop) {
  overflow: hidden;
}
.newspecs {
  width: calc((100% - 40px) / 4) !important;
  width: -moz-calc((100% - 40px) / 4) !important;
  width: -webkit-calc((100% - 40px) / 4) !important;
  width: -o-calc((100% - 40px) / 4) !important;
  width: -ms-calc((100% - 40px) / 4) !important;
}
.bcd-productDetail-box .commodity-detail .base li {
  height: 36px;
  line-height: 36px;
  width: 100%;
  margin-right: 20px;
  overflow: hidden;
  font-size: 14px;
}
.bcd-productDetail-box .commodity-detail .specs > li:nth-child(2n) {
  margin-right: 0;
}
.bcd-productDetail-box .commodity-detail .specs > li.fill {
  height: auto;
  width: 100%;
  border-top: 1px dashed #dadada;
  margin: 10px 0 0;
  padding: 5px 0 0;
}
.bcd-productDetail-box .commodity-detail .specs .attribute-l {
  color: #333;
  text-align: justify;
  overflow: hidden;
  white-space: nowrap;
}
.bcd-productDetail-box .commodity-detail .specs .attribute-r {
  color: #333;
  display: contents;
}
.bcd-productDetail-box .commodity-detail .specs .attribute-r a.upload-pic {
  display: block;
  height: 36px;
  line-height: 36px;
}
.bcd-productDetail-box .commodity-detail .specs .attribute-r a.upload-pic img.label-preview {
  vertical-align: middle;
  height: 24px;
}
.bcd-productDetail-box .commodity-detail .specs .red {
  color: #f14c4a;
}
.bcd-productDetail-box .commodity-detail .specs .discount {
  display: inline-block;
  height: 16px;
  line-height: 16px;
  background: #f14c4a;
  color: #fff;
  font-size: 12px;
  margin-left: 8px;
  padding: 0 6px;
}

.bcd-productDetail-box .commodity-detail {
  border: 1px solid #ddd;
  margin: 24px 0 15px;
  background: #fff;
}
.bcd-productDetail-box .commodity-detail .titles {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #0c78cf;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
}
.titles li.curr {
  background: #0c78cf;
}
.titles li.curr a {
  color: #fff;
  padding: 0 20px;
  font-size: 14px;
}

/* .bcd-productDetail-box .commodity-detail .detail-content ul {
  margin-bottom: 16px;
} */
.bcd-productDetail-box .commodity-detail .detail-content ul:last-child {
  margin-bottom: 0;
}
.bcd-productDetail-box .commodity-detail .detail-content .infos {
  font-size: 12px;
  color: #666;
  line-height: 24px;
  margin-bottom: 15px;
}
/*下方产品介绍  结束*/

/*产品详情总样式 结束*/

.location {
  margin: 8px 0;
  overflow: hidden;
  line-height: 24px;
  font-size: 12px;
  color: #666;
  background: url('~@/assets/image/images/icons/location_icon.png') no-repeat 0 6px;
  padding-left: 14px;
  width: calc(100% - 14px);
  width: -moz-calc(100% - 14px);
  width: -webkit-calc(100% - 14px);
  width: -o-calc(100% - 14px);
  width: -ms-calc(100% - 14px);
}
.location .crumb-size {
  max-width: 300px;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.location .crumb-size.curr a {
  color: #0d78cf;
}

/*今日资讯信息*/

.information {
  margin: 8px;
}
.information .single {
  cursor: pointer;
  margin: 8px;
  width: calc((100% - 48px) / 3);
  width: -moz-calc((100% - 48px) / 3);
  width: -webkit-calc((100% - 48px) / 3);
  width: -o-calc((100% - 48px) / 3);
  width: -ms-calc((100% - 48px) / 3);
}
.information .single:hover .pic img {
  transform: scale(1.1);
}
.information .pic {
  width: 88px;
  height: 88px;
  margin-right: 10px;
}
.information .pic img {
  width: 100%;
  height: 100%;
  transition: 0.3s;
}

.information .word-group {
  width: calc(100% - 98px);
  width: -moz-calc(100% - 98px);
  width: -webkit-calc(100% - 98px);
  width: -o-calc(100% - 98px);
  width: -ms-calc(100% - 98px);
}
.information .tit {
  margin-bottom: 4px;
  display: block;
  color: #666;
  font-size: 16px;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.information .single:hover .tit {
  color: #0d78cf;
  transition: 0.3s;
}
.information .info {
  line-height: 20px;
  color: #999;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  max-height: 58px;
}
.detail-content .outDiv{
  max-height: 600px;
  overflow-y: auto;
}
.detail-content .outDiv .outDic-top {
  display: flex;
}
.detail-content .jinriswiperDown {
  position: relative;
  margin-top: 10px;
}
.detail-content .jinriswiperDown li{
    height: 50px;
    width: calc(20% - 8px);
    cursor: pointer;
    border: 1px solid #ddd;
    margin-right: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media screen and (max-width: 768px){
      width : calc(50% - 5px);
    }
}
.detail-content .jinriswiperDown li{
  border: 2px solid red;
}
.detail-content .jinriswiperDown li span{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 18px;
    font-weight: 800;
    color: #333;
    text-align: center
}
.detail-content .jinriswiperDown .arrow-right{
  z-index: 9;
    width: 22px;
    height: 48px;
    position: absolute;
    top: 50%;
    margin-top: -24px;
    right: 0;
    background: url("~@/assets/images/product_detail/outreach_more.png")
    no-repeat center;
    cursor: pointer;
}
@media screen and (min-width: 111px) and (max-width: 768px) {
  .bcd-productDetail-box .commodity-detail .detail-content .specs {
    margin-top: 20px;
  }
  /* .textTit{
    font-size: 16px;
    margin-top: 10px;
  } */
  .z-container {
    width: 100%;
  }
  .bcd-productDetail-box .commodity-detail .titles {
    width: 100%;
  }
  .detail-content {
    flex-direction: column;
  }
  .detail-content .outDiv .outDic-top,
  .box-type {
    flex-direction: column;
  }
  .bcd-productDetail-box .commodity-detail .specs {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 20px;
    height: auto !important;
  }
  .detail-content > div:first-child,
  .detail-content .outDiv > div:first-child,
  .bcd-productDetail-box .commodity-detail .detail-content ul:last-child,
  .box-type .doubian,
  .box-type .doubiantext {
    width: 100% !important;
  }
  .detail-content .outDiv > div:nth-child(2) {
    height: auto !important;
  }
  .bcd-productDetail-box .commodity-detail .detail-content ul:last-child,
  .box-type .doubiantext {
    margin-left: 0 !important;
    height: auto !important;
  }
  .swiperDown1 {
    width: 100% !important;
  }
}
/* @media screen and (min-width:426px) and (max-width: 768px) {
    .bcd-productDetail-box .related-recommend .more-product .img-box{margin:0 auto;}
    .bcd-productDetail-box .commodity-information{
        margin:10px;
        width: calc(100% - 20px);
        width: -o-calc(100% - 20px);
        width: -ms-calc(100% - 20px);
    }
    .bcd-productDetail-box .commodity-show .commodity-pic .pic,
    .bcd-productDetail-box .commodity-show .commodity-pic .pic span{height: 200px;}
    .bcd-productDetail-box .commodity-show .commodity-infos .infos,
    .bcd-productDetail-box .commodity-show .commodity-infos .infos .in{min-height:auto;}
    .bcd-productDetail-box .commodity-show .commodity-pic{float: unset;}
    .bcd-productDetail-box .related-recommend .more-product .scroll-box,
    .bcd-productDetail-box .related-recommend .more-product .bottom-switch,
    .bcd-productDetail-box .commodity-show .commodity-pic .pic,
    .bcd-productDetail-box .commodity-show .commodity-pic .pic span,
    .bcd-productDetail-box .related-recommend .more-product .img-box,
    .bcd-productDetail-box .related-recommend .more-product .img-box img{width:100%;}
    .bcd-productDetail-box .commodity-detail .specs li{height:auto;width: 100%;}
    .more-product .swiper-wrapper{display:block;}
    .bcd-productDetail-box .related-recommend .title-box{margin:10px;}
    .bcd-productDetail-box .related-recommend .more-product .bottom-switch .bottom-content{margin-top:0;}
    .bcd-productDetail-box .related-recommend .more-product .product{margin-top:10px;width:calc(50% - 6px);width:-webkit-calc(50% - 6px);margin-right:10px;}
    .bcd-productDetail-box .related-recommend .more-product .product:nth-of-type(even){margin-right:0;}
    .bcd-productDetail-box .commodity-show .commodity-infos .tit,
    .bcd-productDetail-box .related-recommend .title-box .title{font-size:16px;}
    .bcd-productDetail-box .related-recommend .more-product .product-name,
    .bcd-productDetail-box .commodity-detail .specs li{font-size:12px;}
    .bcd-productDetail-box .related-recommend .more-product .product-name{line-height:30px;}
    .bcd-productDetail-box .commodity-show .commodity-infos .btn-group li a{font-size:12px;height:30px;line-height:30px;padding:0 8px;}

    .content-box{position: relative;}
    .content-left-box,.content-right-box{position:absolute;top:0px;bottom:0px;z-index:9;background:#fff;border-left: 1px solid #dddddd;border-right: 1px solid #dddddd;height:auto;width:150px;}
    .content-left-box{left:0;}
    .content-right-box{right:-1px;}
    .block-content{position: relative;}
    .btn-left,.btn-right{position: absolute;top:160px; width:30px;height:30px; border-radius:20px;z-index:8;background-size: contain;}
    .btn-left{left:2px;background-image: url("~@/assets/image/images/icons/arrow_right_circular.png");  }
    .btn-right{right:2px; background-image: url("~@/assets/image/images/icons/arrow_left_circular.png");}
    .close-left,.close-right{position: absolute;top:10px; width:20px;height:20px; border-radius:10px;z-index:10;background-size: contain;background-image: url("~@/assets/image/images/icons/close_right_top.png")}
    .close-left{left:120px;}
    .close-right{right:120px;}
    .comment .comment-info .comment-percent{width:100%;}
    .comment .comment-info .percent-info{width:100%;margin:20px 0 0 0px;}
    .comment .comments-list .tab-main{height:auto;border:1px solid #f5f5f5;}
    .comment .comment-item .comment-column{margin-left:0px;}
    .comment .comment-item .comment-star{margin-left:140px;}
    #zoom img{width: 200px;height: 200px;}
    #zoom .content{width: 200px;height: 200px;margin: -100px 0 0 -100px;}
    #zoom .content a{width: 200px;height: 200px;}
} */
</style>
<style scoped>
.bgM {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.85);
  overflow: hidden;
}
.bgM img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  margin: auto;
}
.work_attendance {
  margin-top: 64px;
  height: calc(100% - 114px);
  overflow: scroll;
}
.content {
  margin-top: 0;
}
.bgM .swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-pagination-bullet-active {
  background-color: #fff;
}
.upload-pic video {
  height: 24px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/template/newFlowDetail.vue